/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global global, define, Symbol, Reflect, Promise, SuppressedError */
var __extends;
var __assign;
var __rest;
var __decorate;
var __param;
var __esDecorate;
var __runInitializers;
var __propKey;
var __setFunctionName;
var __metadata;
var __awaiter;
var __generator;
var __exportStar;
var __values;
var __read;
var __spread;
var __spreadArrays;
var __spreadArray;
var __await;
var __asyncGenerator;
var __asyncDelegator;
var __asyncValues;
var __makeTemplateObject;
var __importStar;
var __importDefault;
var __classPrivateFieldGet;
var __classPrivateFieldSet;
var __classPrivateFieldIn;
var __createBinding;
var __addDisposableResource;
var __disposeResources;
(function (factory) {
    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
    if (typeof define === "function" && define.amd) {
        define("tslib", ["exports"], function (exports) { factory(createExporter(root, createExporter(exports))); });
    }
    else if (typeof module === "object" && typeof module.exports === "object") {
        factory(createExporter(root, createExporter(module.exports)));
    }
    else {
        factory(createExporter(root));
    }
    function createExporter(exports, previous) {
        if (exports !== root) {
            if (typeof Object.create === "function") {
                Object.defineProperty(exports, "__esModule", { value: true });
            }
            else {
                exports.__esModule = true;
            }
        }
        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
    }
})
(function (exporter) {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };

    __extends = function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };

    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };

    __rest = function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    };

    __decorate = function (decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };

    __param = function (paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    };

    __esDecorate = function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
        function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
        var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
        var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
        var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
        var _, done = false;
        for (var i = decorators.length - 1; i >= 0; i--) {
            var context = {};
            for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
            for (var p in contextIn.access) context.access[p] = contextIn.access[p];
            context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
            var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
            if (kind === "accessor") {
                if (result === void 0) continue;
                if (result === null || typeof result !== "object") throw new TypeError("Object expected");
                if (_ = accept(result.get)) descriptor.get = _;
                if (_ = accept(result.set)) descriptor.set = _;
                if (_ = accept(result.init)) initializers.unshift(_);
            }
            else if (_ = accept(result)) {
                if (kind === "field") initializers.unshift(_);
                else descriptor[key] = _;
            }
        }
        if (target) Object.defineProperty(target, contextIn.name, descriptor);
        done = true;
    };

    __runInitializers = function (thisArg, initializers, value) {
        var useValue = arguments.length > 2;
        for (var i = 0; i < initializers.length; i++) {
            value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
        }
        return useValue ? value : void 0;
    };

    __propKey = function (x) {
        return typeof x === "symbol" ? x : "".concat(x);
    };

    __setFunctionName = function (f, name, prefix) {
        if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
        return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
    };

    __metadata = function (metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    };

    __awaiter = function (thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };

    __generator = function (thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (g && (g = 0, op[0] && (_ = 0)), _) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    };

    __exportStar = function(m, o) {
        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
    };

    __createBinding = Object.create ? (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
            desc = { enumerable: true, get: function() { return m[k]; } };
        }
        Object.defineProperty(o, k2, desc);
    }) : (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });

    __values = function (o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    };

    __read = function (o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    };

    /** @deprecated */
    __spread = function () {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    };

    /** @deprecated */
    __spreadArrays = function () {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    __spreadArray = function (to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || Array.prototype.slice.call(from));
    };

    __await = function (v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    };

    __asyncGenerator = function (thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    };

    __asyncDelegator = function (o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
    };

    __asyncValues = function (o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    };

    __makeTemplateObject = function (cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    var __setModuleDefault = Object.create ? (function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
    }) : function(o, v) {
        o["default"] = v;
    };

    __importStar = function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        __setModuleDefault(result, mod);
        return result;
    };

    __importDefault = function (mod) {
        return (mod && mod.__esModule) ? mod : { "default": mod };
    };

    __classPrivateFieldGet = function (receiver, state, kind, f) {
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
        return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
    };

    __classPrivateFieldSet = function (receiver, state, value, kind, f) {
        if (kind === "m") throw new TypeError("Private method is not writable");
        if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
        if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
        return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
    };

    __classPrivateFieldIn = function (state, receiver) {
        if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
        return typeof state === "function" ? receiver === state : state.has(receiver);
    };

    __addDisposableResource = function (env, value, async) {
        if (value !== null && value !== void 0) {
            if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
            var dispose;
            if (async) {
                if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
                dispose = value[Symbol.asyncDispose];
            }
            if (dispose === void 0) {
                if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
                dispose = value[Symbol.dispose];
            }
            if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
            env.stack.push({ value: value, dispose: dispose, async: async });
        }
        else if (async) {
            env.stack.push({ async: true });
        }
        return value;
    };

    var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
        var e = new Error(message);
        return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
    };

    __disposeResources = function (env) {
        function fail(e) {
            env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
            env.hasError = true;
        }
        function next() {
            while (env.stack.length) {
                var rec = env.stack.pop();
                try {
                    var result = rec.dispose && rec.dispose.call(rec.value);
                    if (rec.async) return Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
                }
                catch (e) {
                    fail(e);
                }
            }
            if (env.hasError) throw env.error;
        }
        return next();
    };

    exporter("__extends", __extends);
    exporter("__assign", __assign);
    exporter("__rest", __rest);
    exporter("__decorate", __decorate);
    exporter("__param", __param);
    exporter("__esDecorate", __esDecorate);
    exporter("__runInitializers", __runInitializers);
    exporter("__propKey", __propKey);
    exporter("__setFunctionName", __setFunctionName);
    exporter("__metadata", __metadata);
    exporter("__awaiter", __awaiter);
    exporter("__generator", __generator);
    exporter("__exportStar", __exportStar);
    exporter("__createBinding", __createBinding);
    exporter("__values", __values);
    exporter("__read", __read);
    exporter("__spread", __spread);
    exporter("__spreadArrays", __spreadArrays);
    exporter("__spreadArray", __spreadArray);
    exporter("__await", __await);
    exporter("__asyncGenerator", __asyncGenerator);
    exporter("__asyncDelegator", __asyncDelegator);
    exporter("__asyncValues", __asyncValues);
    exporter("__makeTemplateObject", __makeTemplateObject);
    exporter("__importStar", __importStar);
    exporter("__importDefault", __importDefault);
    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
    exporter("__classPrivateFieldIn", __classPrivateFieldIn);
    exporter("__addDisposableResource", __addDisposableResource);
    exporter("__disposeResources", __disposeResources);
});

var tools = (function (exports, Q) {
    'use strict';

    /**
     * A color utility library.  Inspired by tinycolor, but modified to work for us
     */
    var Color = /** @class */ (function () {
        function Color(color) {
            var rgb = Color.inputToRGB(color);
            this._originalInput = color,
                this._r = rgb.r,
                this._g = rgb.g,
                this._b = rgb.b,
                this._a = rgb.a,
                this._roundA = Math.round(100 * this._a) / 100;
            // Don't let the range of [0,255] come back in [0,1].
            // Potentially lose a little bit of precision here, but will fix issues where
            // .5 gets interpreted as half of the total, instead of half of 1
            // If it was supposed to be 128, this was already taken care of by `inputToRgb`
            if (this._r < 1) {
                this._r = Math.round(this._r);
            }
            if (this._g < 1) {
                this._g = Math.round(this._g);
            }
            if (this._b < 1) {
                this._b = Math.round(this._b);
            }
            this._ok = rgb.ok;
        }
        Color.prototype.isDark = function () {
            return this.getBrightness() < 128;
        };
        Color.prototype.isLight = function () {
            return !this.isDark();
        };
        Color.prototype.isValid = function () {
            return this._ok;
        };
        Color.prototype.getOriginalInput = function () {
            return this._originalInput;
        };
        Color.prototype.getAlpha = function () {
            return this._a;
        };
        Color.prototype.getBrightness = function () {
            // http://www.w3.org/TR/AERT#color-contrast
            var rgb = this.toRgb();
            return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
        };
        Color.prototype.getLuminance = function () {
            // http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
            var rgb = this.toRgb();
            var R;
            var G;
            var B;
            var rsRGB = rgb.r / 255;
            var gsRGB = rgb.g / 255;
            var bsRGB = rgb.b / 255;
            if (rsRGB <= 0.03928) {
                R = rsRGB / 12.92;
            }
            else {
                R = Math.pow(((rsRGB + 0.055) / 1.055), 2.4);
            }
            if (gsRGB <= 0.03928) {
                G = gsRGB / 12.92;
            }
            else {
                G = Math.pow(((gsRGB + 0.055) / 1.055), 2.4);
            }
            if (bsRGB <= 0.03928) {
                B = bsRGB / 12.92;
            }
            else {
                B = Math.pow(((bsRGB + 0.055) / 1.055), 2.4);
            }
            return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
        };
        Color.prototype.setAlpha = function (value) {
            this._a = Color.boundAlpha(value);
            this._roundA = Math.round(100 * this._a) / 100;
            return this;
        };
        Color.prototype.toHsv = function () {
            var hsv = Color.rgbToHsv(this._r, this._g, this._b);
            return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
        };
        Color.prototype.toHsvString = function () {
            var hsv = Color.rgbToHsv(this._r, this._g, this._b);
            var h = Math.round(hsv.h * 360);
            var s = Math.round(hsv.s * 100);
            var v = Math.round(hsv.v * 100);
            return (this._a == 1) ?
                "hsv(" + h + ", " + s + "%, " + v + "%)" :
                "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
        };
        Color.prototype.toHsl = function () {
            var hsl = Color.rgbToHsl(this._r, this._g, this._b);
            return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
        };
        Color.prototype.toHslString = function () {
            var hsl = Color.rgbToHsl(this._r, this._g, this._b);
            var h = Math.round(hsl.h * 360);
            var s = Math.round(hsl.s * 100);
            var l = Math.round(hsl.l * 100);
            return (this._a == 1) ?
                "hsl(" + h + ", " + s + "%, " + l + "%)" :
                "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
        };
        Color.prototype.toHex = function (allow3Char) {
            if (allow3Char === void 0) { allow3Char = true; }
            return Color.rgbToHex(this._r, this._g, this._b, allow3Char);
        };
        Color.prototype.toHexString = function (allow3Char) {
            if (allow3Char === void 0) { allow3Char = true; }
            return "#" + this.toHex(allow3Char);
        };
        Color.prototype.toHex8 = function () {
            return Color.rgbaToHex(this._r, this._g, this._b, this._a);
        };
        Color.prototype.toHex8String = function () {
            return "#" + this.toHex8();
        };
        Color.prototype.toRgb = function () {
            return { r: Math.round(this._r), g: Math.round(this._g), b: Math.round(this._b), a: this._a };
        };
        Color.prototype.toRgbString = function () {
            return (this._a == 1) ?
                "rgb(" + Math.round(this._r) + ", " +
                    Math.round(this._g) + ", " +
                    Math.round(this._b) + ")" :
                "rgba(" + Math.round(this._r) + ", " +
                    Math.round(this._g) + ", " +
                    Math.round(this._b) + ", " +
                    this._roundA + ")";
        };
        Color.prototype.toPercentageRgb = function () {
            return {
                r: Math.round(Color.bound01(this._r, 255) * 100) + "%",
                g: Math.round(Color.bound01(this._g, 255) * 100) + "%",
                b: Math.round(Color.bound01(this._b, 255) * 100) + "%", a: this._a
            };
        };
        Color.prototype.toPercentageRgbString = function () {
            return (this._a == 1) ?
                "rgb(" +
                    Math.round(Color.bound01(this._r, 255) * 100) + "%, " +
                    Math.round(Color.bound01(this._g, 255) * 100) + "%, " +
                    Math.round(Color.bound01(this._b, 255) * 100) + "%)" :
                "rgba(" +
                    Math.round(Color.bound01(this._r, 255) * 100) + "%, " +
                    Math.round(Color.bound01(this._g, 255) * 100) + "%, " +
                    Math.round(Color.bound01(this._b, 255) * 100) + "%, " +
                    this._roundA + ")";
        };
        Color.prototype.toName = function () {
            if (this._a === 0) {
                return "transparent";
            }
            if (this._a < 1) {
                return undefined;
            }
            return Color.hexNames[Color.rgbToHex(this._r, this._g, this._b, true)] || undefined;
        };
        Color.prototype.toString = function (format) {
            var formatSet = !!format;
            var formattedString;
            var hasAlpha = this._a < 1 && this._a >= 0;
            var needsAlphaFormat = !formatSet && hasAlpha &&
                (format === "hex" || format === "hex6" || format === "hex3" || format === "name");
            if (needsAlphaFormat) {
                // Special case for "transparent", all other non-alpha formats
                // will return rgba when there is transparency.
                if (format === "name" && this._a === 0) {
                    return this.toName();
                }
                return this.toRgbString();
            }
            if (format === "rgb") {
                formattedString = this.toRgbString();
            }
            if (format === "prgb") {
                formattedString = this.toPercentageRgbString();
            }
            if (format === "hex" || format === "hex6") {
                formattedString = this.toHexString();
            }
            if (format === "hex3") {
                formattedString = this.toHexString(true);
            }
            if (format === "hex8") {
                formattedString = this.toHex8String();
            }
            if (format === "name") {
                formattedString = this.toName();
            }
            if (format === "hsl") {
                formattedString = this.toHslString();
            }
            if (format === "hsv") {
                formattedString = this.toHsvString();
            }
            return formattedString || this.toHexString();
        };
        Color.prototype._applyModification = function (fn, args) {
            var color = fn.apply(null, [this].concat([].slice.call(args)));
            this._r = color._r;
            this._g = color._g;
            this._b = color._b;
            this.setAlpha(color._a);
            return this;
        };
        Color.prototype.lighten = function (amount) {
            return this._applyModification(Color.lighten, arguments);
        };
        Color.prototype.brighten = function (amount) {
            return this._applyModification(Color.brighten, arguments);
        };
        Color.prototype.darken = function (amount) {
            return this._applyModification(Color.darken, arguments);
        };
        Color.prototype.desaturate = function (amount) {
            return this._applyModification(Color.desaturate, arguments);
        };
        Color.prototype.saturate = function (amount) {
            return this._applyModification(Color.saturate, arguments);
        };
        Color.prototype.greyscale = function () {
            return this._applyModification(Color.greyscale, arguments);
        };
        Color.prototype.spin = function (amount) {
            return this._applyModification(Color.spin, arguments);
        };
        Color.prototype._applyCombination = function (fn, args) {
            return fn.apply(null, [this].concat([].slice.call(args)));
        };
        Color.prototype.analogous = function (results, slices) {
            return this._applyCombination(Color.analogous, arguments);
        };
        Color.prototype.complement = function () {
            return this._applyCombination(Color.complement, arguments);
        };
        Color.prototype.monochromatic = function (results) {
            return this._applyCombination(Color.monochromatic, arguments);
        };
        Color.prototype.splitcomplement = function () {
            return this._applyCombination(Color.splitcomplement, arguments);
        };
        Color.prototype.triad = function () {
            return this._applyCombination(Color.triad, arguments);
        };
        Color.prototype.tetrad = function () {
            return this._applyCombination(Color.tetrad, arguments);
        };
        // If input is an object, force 1 into "1.0" to handle ratios properly
        // String input requires "1.0" as input, so 1 will be treated as 1
        Color.fromRatio = function (color) {
            if (typeof color == "object") {
                var newColor = {};
                for (var i in color) {
                    if (color.hasOwnProperty(i)) {
                        if (i === "a") {
                            newColor[i] = color[i];
                        }
                        else {
                            newColor[i] = Color.convertToPercentage(color[i]);
                        }
                    }
                }
                color = newColor;
            }
            return new Color(color);
        };
        // Given a string or object, convert that input to RGB
        // Possible string inputs:
        //
        //     "red"
        //     "#f00" or "f00"
        //     "#ff0000" or "ff0000"
        //     "#ff000000" or "ff000000"
        //     "rgb 255 0 0" or "rgb (255, 0, 0)"
        //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
        //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
        //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
        //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
        //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
        //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
        //
        Color.inputToRGB = function (color) {
            var rgb = { r: 0, g: 0, b: 0 };
            var a = 1;
            var ok = false;
            var format;
            if (color instanceof Color) {
                rgb.r = color._r;
                rgb.b = color._b;
                rgb.g = color._g;
                a = color._a;
            }
            if (typeof color == "string") {
                color = Color.stringInputToObject(color);
            }
            if (typeof color == "object" && color != null) {
                if (color.hasOwnProperty("r") && color.hasOwnProperty("g") && color.hasOwnProperty("b")) {
                    rgb = Color.rgbToRgb(color.r, color.g, color.b);
                    ok = true;
                    format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
                }
                else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("v")) {
                    color.s = Color.convertToPercentage(color.s);
                    color.v = Color.convertToPercentage(color.v);
                    rgb = Color.hsvToRgb(color.h, color.s, color.v);
                    ok = true;
                    format = "hsv";
                }
                else if (color.hasOwnProperty("h") && color.hasOwnProperty("s") && color.hasOwnProperty("l")) {
                    color.s = Color.convertToPercentage(color.s);
                    color.l = Color.convertToPercentage(color.l);
                    rgb = Color.hslToRgb(color.h, color.s, color.l);
                    ok = true;
                    format = "hsl";
                }
                if (color.hasOwnProperty("a")) {
                    a = color.a;
                }
            }
            a = Color.boundAlpha(a);
            return {
                ok: ok,
                format: color.format || format,
                r: Math.min(255, Math.max(rgb.r, 0)),
                g: Math.min(255, Math.max(rgb.g, 0)),
                b: Math.min(255, Math.max(rgb.b, 0)),
                a: a
            };
        };
        // Conversion Functions
        // --------------------
        // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
        // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
        // `rgbToRgb`
        // Handle bounds / percentage checking to conform to CSS color spec
        // <http://www.w3.org/TR/css3-color/>
        // *Assumes:* r, g, b in [0, 255] or [0, 1]
        // *Returns:* { r, g, b } in [0, 255]
        Color.rgbToRgb = function (r, g, b) {
            return {
                r: Color.bound01(r, 255) * 255,
                g: Color.bound01(g, 255) * 255,
                b: Color.bound01(b, 255) * 255
            };
        };
        // `rgbToHsl`
        // Converts an RGB color value to HSL.
        // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
        // *Returns:* { h, s, l } in [0,1]
        Color.rgbToHsl = function (r, g, b) {
            r = Color.bound01(r, 255);
            g = Color.bound01(g, 255);
            b = Color.bound01(b, 255);
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var h;
            var s;
            var l = (max + min) / 2;
            if (max == min) {
                h = s = 0; // achromatic
            }
            else {
                var d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
                switch (max) {
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return { h: h, s: s, l: l };
        };
        // `hslToRgb`
        // Converts an HSL color value to RGB.
        // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
        // *Returns:* { r, g, b } in the set [0, 255]
        Color.hslToRgb = function (h, s, l) {
            var r;
            var g;
            var b;
            h = Color.bound01(h, 360);
            s = Color.bound01(s, 100);
            l = Color.bound01(l, 100);
            function hue2rgb(p, q, t) {
                if (t < 0)
                    t += 1;
                if (t > 1)
                    t -= 1;
                if (t < 1 / 6)
                    return p + (q - p) * 6 * t;
                if (t < 1 / 2)
                    return q;
                if (t < 2 / 3)
                    return p + (q - p) * (2 / 3 - t) * 6;
                return p;
            }
            if (s === 0) {
                r = g = b = l; // achromatic
            }
            else {
                var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                var p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            return { r: r * 255, g: g * 255, b: b * 255 };
        };
        // `rgbToHsv`
        // Converts an RGB color value to HSV
        // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
        // *Returns:* { h, s, v } in [0,1]
        Color.rgbToHsv = function (r, g, b) {
            r = Color.bound01(r, 255);
            g = Color.bound01(g, 255);
            b = Color.bound01(b, 255);
            var max = Math.max(r, g, b);
            var min = Math.min(r, g, b);
            var h;
            var s;
            var v = max;
            var d = max - min;
            s = max === 0 ? 0 : d / max;
            if (max == min) {
                h = 0; // achromatic
            }
            else {
                switch (max) {
                    case r:
                        h = (g - b) / d + (g < b ? 6 : 0);
                        break;
                    case g:
                        h = (b - r) / d + 2;
                        break;
                    case b:
                        h = (r - g) / d + 4;
                        break;
                }
                h /= 6;
            }
            return { h: h, s: s, v: v };
        };
        // `hsvToRgb`
        // Converts an HSV color value to RGB.
        // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
        // *Returns:* { r, g, b } in the set [0, 255]
        Color.hsvToRgb = function (h, s, v) {
            h = Color.bound01(h, 360) * 6;
            s = Color.bound01(s, 100);
            v = Color.bound01(v, 100);
            var i = Math.floor(h);
            var f = h - i;
            var p = v * (1 - s);
            var q = v * (1 - f * s);
            var t = v * (1 - (1 - f) * s);
            var mod = i % 6;
            var r = [v, q, p, p, t, v][mod];
            var g = [t, v, v, q, p, p][mod];
            var b = [p, p, t, v, v, q][mod];
            return { r: r * 255, g: g * 255, b: b * 255 };
        };
        // `rgbToHex`
        // Converts an RGB color to hex
        // Assumes r, g, and b are contained in the set [0, 255]
        // Returns a 3 or 6 character hex
        Color.rgbToHex = function (r, g, b, allow3Char) {
            var hex = [
                Color.pad2(Math.round(r).toString(16)),
                Color.pad2(Math.round(g).toString(16)),
                Color.pad2(Math.round(b).toString(16))
            ];
            // Return a 3 character hex if possible
            if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) &&
                hex[2].charAt(0) == hex[2].charAt(1)) {
                return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
            }
            return hex.join("");
        };
        // `rgbaToHex`
        // Converts an RGBA color plus alpha transparency to hex
        // Assumes r, g, b and a are contained in the set [0, 255]
        // Returns an 8 character hex
        Color.rgbaToHex = function (r, g, b, a) {
            var hex = [
                Color.pad2(Color.convertDecimalToHex(a)),
                Color.pad2(Math.round(r).toString(16)),
                Color.pad2(Math.round(g).toString(16)),
                Color.pad2(Math.round(b).toString(16))
            ];
            return hex.join("");
        };
        // `equals`
        // Can be called with any tinycolor input
        Color.equals = function (color1, color2) {
            if (!color1 || !color2) {
                return false;
            }
            return new Color(color1).toRgbString() == new Color(color2).toRgbString();
        };
        Color.random = function () {
            return Color.fromRatio({
                r: Math.random(),
                g: Math.random(),
                b: Math.random()
            });
        };
        // Modification Functions
        // ----------------------
        // Thanks to less.js for some of the basics here
        // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
        Color.desaturate = function (color, amount) {
            amount = (amount === 0) ? 0 : (amount || 10);
            var hsl = new Color(color).toHsl();
            hsl.s -= amount / 100;
            hsl.s = Color.clamp01(hsl.s);
            return new Color(hsl);
        };
        Color.saturate = function (color, amount) {
            amount = (amount === 0) ? 0 : (amount || 10);
            var hsl = new Color(color).toHsl();
            hsl.s += amount / 100;
            hsl.s = Color.clamp01(hsl.s);
            return new Color(hsl);
        };
        Color.greyscale = function (color) {
            return Color.desaturate(color, 100);
        };
        Color.lighten = function (color, amount) {
            amount = (amount === 0) ? 0 : (amount || 10);
            var hsl = new Color(color).toHsl();
            hsl.l += amount / 100;
            hsl.l = Color.clamp01(hsl.l);
            return new Color(hsl);
        };
        Color.brighten = function (color, amount) {
            amount = (amount === 0) ? 0 : (amount || 10);
            var rgb = new Color(color).toRgb();
            rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
            rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
            rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
            return new Color(rgb);
        };
        Color.darken = function (color, amount) {
            amount = (amount === 0) ? 0 : (amount || 10);
            var hsl = new Color(color).toHsl();
            hsl.l -= amount / 100;
            hsl.l = Color.clamp01(hsl.l);
            return new Color(hsl);
        };
        // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
        // Values outside of this range will be wrapped into this range.
        Color.spin = function (color, amount) {
            var hsl = new Color(color).toHsl();
            var hue = (Math.round(hsl.h) + amount) % 360;
            hsl.h = hue < 0 ? 360 + hue : hue;
            return new Color(hsl);
        };
        // Combination Functions
        // ---------------------
        // Thanks to jQuery xColor for some of the ideas behind these
        // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
        Color.complement = function (color) {
            var hsl = new Color(color).toHsl();
            hsl.h = (hsl.h + 180) % 360;
            return new Color(hsl);
        };
        Color.triad = function (color) {
            var hsl = new Color(color).toHsl();
            var h = hsl.h;
            return [
                new Color(color),
                new Color({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
                new Color({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
            ];
        };
        Color.tetrad = function (color) {
            var hsl = new Color(color).toHsl();
            var h = hsl.h;
            return [
                new Color(color),
                new Color({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
                new Color({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
                new Color({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
            ];
        };
        Color.splitcomplement = function (color) {
            var hsl = new Color(color).toHsl();
            var h = hsl.h;
            return [
                new Color(color),
                new Color({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
                new Color({ h: (h + 216) % 360, s: hsl.s, l: hsl.l })
            ];
        };
        Color.analogous = function (color, results, slices) {
            results = results || 6;
            slices = slices || 30;
            var hsl = new Color(color).toHsl();
            var part = 360 / slices;
            var ret = [new Color(color)];
            // tslint:disable-next-line:no-bitwise
            for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results;) {
                hsl.h = (hsl.h + part) % 360;
                ret.push(new Color(hsl));
            }
            return ret;
        };
        Color.monochromatic = function (color, results) {
            results = results || 6;
            var hsv = new Color(color).toHsv();
            var h = hsv.h;
            var s = hsv.s;
            var v = hsv.v;
            var ret = [];
            var modification = 1 / results;
            while (results--) {
                ret.push(new Color({ h: h, s: s, v: v }));
                v = (v + modification) % 1;
            }
            return ret;
        };
        // Utility Functions
        // ---------------------
        Color.mix = function (color1, color2, amount) {
            amount = (amount === 0) ? 0 : (amount || 50);
            var rgb1 = new Color(color1).toRgb();
            var rgb2 = new Color(color2).toRgb();
            var p = amount / 100;
            var w = p * 2 - 1;
            var a = rgb2.a - rgb1.a;
            var w1;
            if (w * a == -1) {
                w1 = w;
            }
            else {
                w1 = (w + a) / (1 + w * a);
            }
            w1 = (w1 + 1) / 2;
            var w2 = 1 - w1;
            var rgba = {
                r: rgb2.r * w1 + rgb1.r * w2,
                g: rgb2.g * w1 + rgb1.g * w2,
                b: rgb2.b * w1 + rgb1.b * w2,
                a: rgb2.a * p + rgb1.a * (1 - p)
            };
            return new Color(rgba);
        };
        // Readability Functions
        // ---------------------
        // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
        // `contrast`
        // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
        Color.readability = function (color1, color2) {
            var c1 = new Color(color1);
            var c2 = new Color(color2);
            return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) /
                (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
        };
        // `isReadable`
        // Ensure that foreground and background color combinations meet WCAG2 guidelines.
        // The third argument is an optional Object.
        //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
        //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
        // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
        // *Example*
        //    tinycolor.isReadable("#000", "#111") => false
        //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
        Color.isReadable = function (color1, color2, wcag2) {
            var readability = Color.readability(color1, color2);
            var wcag2Parms;
            var out;
            out = false;
            wcag2Parms = Color.validateWCAG2Parms(wcag2);
            switch (wcag2Parms.level + wcag2Parms.size) {
                case "AAsmall":
                case "AAAlarge":
                    out = readability >= 4.5;
                    break;
                case "AAlarge":
                    out = readability >= 3;
                    break;
                case "AAAsmall":
                    out = readability >= 7;
                    break;
            }
            return out;
        };
        /**
         * Given a base color and a list of possible foreground or background
         * colors for that base, returns the most readable color.
         * Optionally returns Black or White if the most readable color is unreadable.
         * @param baseColor
         * @param colorList
         * @param args
         */
        Color.mostReadable = function (baseColor, colorList, args) {
            var bestColor = null;
            var bestScore = 0;
            var readability;
            var includeFallbackColors;
            var level;
            var size;
            args = args || {};
            includeFallbackColors = args.includeFallbackColors;
            level = args.level;
            size = args.size;
            for (var _i = 0, colorList_1 = colorList; _i < colorList_1.length; _i++) {
                var c = colorList_1[_i];
                readability = Color.readability(baseColor, c);
                if (readability > bestScore) {
                    bestScore = readability;
                    bestColor = new Color(c);
                }
            }
            if (Color.isReadable(baseColor, bestColor, { level: level, size: size }) || !includeFallbackColors) {
                return bestColor;
            }
            else {
                args.includeFallbackColors = false;
                return Color.mostReadable(baseColor, ["#fff", "#000"], args);
            }
        };
        // Utilities
        // ---------
        // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
        Color.flip = function (o) {
            var flipped = {};
            for (var i in o) {
                if (o.hasOwnProperty(i)) {
                    flipped[o[i]] = i;
                }
            }
            return flipped;
        };
        // Return a valid alpha value [0,1] with all invalid values being set to 1
        Color.boundAlpha = function (a) {
            a = parseFloat(a);
            if (isNaN(a) || a < 0 || a > 1) {
                a = 1;
            }
            return a;
        };
        // Take input from [0, n] and return it as [0, 1]
        Color.bound01 = function (n, max) {
            if (Color.isOnePointZero(n)) {
                n = "100%";
            }
            var processPercent = Color.isPercentage(n);
            n = Math.min(max, Math.max(0, parseFloat(n)));
            // Automatically convert percentage into number
            if (processPercent) {
                n = parseInt((n * max).toString(), 10) / 100;
            }
            // Handle floating point rounding errors
            if ((Math.abs(n - max) < 0.000001)) {
                return 1;
            }
            // Convert into [0, 1] range if it isn't already
            return (n % max) / parseFloat(max);
        };
        // Force a number between 0 and 1
        Color.clamp01 = function (val) {
            return Math.min(1, Math.max(0, val));
        };
        // Parse a base-16 hex value into a base-10 integer
        Color.parseIntFromHex = function (val) {
            return parseInt(val, 16);
        };
        // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
        // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
        Color.isOnePointZero = function (n) {
            return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
        };
        // Check to see if string passed in is a percentage
        Color.isPercentage = function (n) {
            return typeof n === "string" && n.indexOf("%") != -1;
        };
        // Force a hex value to have 2 characters
        Color.pad2 = function (c) {
            return c.length == 1 ? "0" + c : "" + c;
        };
        // Replace a decimal with it's percentage value
        Color.convertToPercentage = function (n) {
            if (n <= 1) {
                n = (n * 100) + "%";
            }
            return n;
        };
        // Converts a decimal to a hex value
        Color.convertDecimalToHex = function (d) {
            return Math.round(parseFloat(d) * 255).toString(16);
        };
        // Converts a hex value to a decimal
        Color.convertHexToDecimal = function (h) {
            return (Color.parseIntFromHex(h) / 255);
        };
        // `stringInputToObject`
        // Permissive string parsing.  Take in a number of formats, and output an object
        // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
        Color.stringInputToObject = function (color) {
            var trimLeft = /^[\s,#]+/;
            var trimRight = /\s+$/;
            color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
            var named = false;
            if (Color.names[color]) {
                color = Color.names[color];
                named = true;
            }
            else if (color == "transparent") {
                return { r: 0, g: 0, b: 0, a: 0, format: "name" };
            }
            // Try to match string input using regular expressions.
            // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
            // Just return an object and let the conversion functions handle that.
            // This way the result will be the same whether the tinycolor is initialized with string or object.
            var match;
            // tslint:disable:no-conditional-assignment
            if ((match = Color.matchers.rgb.exec(color))) {
                return { r: match[1], g: match[2], b: match[3] };
            }
            if ((match = Color.matchers.rgba.exec(color))) {
                return { r: match[1], g: match[2], b: match[3], a: match[4] };
            }
            if ((match = Color.matchers.hsl.exec(color))) {
                return { h: match[1], s: match[2], l: match[3] };
            }
            if ((match = Color.matchers.hsla.exec(color))) {
                return { h: match[1], s: match[2], l: match[3], a: match[4] };
            }
            if ((match = Color.matchers.hsv.exec(color))) {
                return { h: match[1], s: match[2], v: match[3] };
            }
            if ((match = Color.matchers.hsva.exec(color))) {
                return { h: match[1], s: match[2], v: match[3], a: match[4] };
            }
            if ((match = Color.matchers.hex8.exec(color))) {
                return {
                    a: Color.convertHexToDecimal(match[1]),
                    r: Color.parseIntFromHex(match[2]),
                    g: Color.parseIntFromHex(match[3]),
                    b: Color.parseIntFromHex(match[4]),
                    format: named ? "name" : "hex8"
                };
            }
            if ((match = Color.matchers.hex6.exec(color))) {
                return {
                    r: Color.parseIntFromHex(match[1]),
                    g: Color.parseIntFromHex(match[2]),
                    b: Color.parseIntFromHex(match[3]),
                    format: named ? "name" : "hex"
                };
            }
            if ((match = Color.matchers.hex3.exec(color))) {
                return {
                    r: Color.parseIntFromHex(match[1] + "" + match[1]),
                    g: Color.parseIntFromHex(match[2] + "" + match[2]),
                    b: Color.parseIntFromHex(match[3] + "" + match[3]),
                    format: named ? "name" : "hex"
                };
            }
            return false;
        };
        Color.validateWCAG2Parms = function (parms) {
            // return valid WCAG2 parms for isReadable.
            // If input parms are invalid, return {"level":"AA", "size":"small"}
            var level;
            var size;
            parms = parms || { level: "AA", size: "small" };
            level = (parms.level || "AA").toUpperCase();
            size = (parms.size || "small").toLowerCase();
            if (level !== "AA" && level !== "AAA") {
                level = "AA";
            }
            if (size !== "small" && size !== "large") {
                size = "small";
            }
            return { level: level, size: size };
        };
        // Big List of Colors
        // ------------------
        // <http://www.w3.org/TR/css3-color/#svg-color>
        Color.names = {
            aliceblue: "f0f8ff",
            antiquewhite: "faebd7",
            aqua: "0ff",
            aquamarine: "7fffd4",
            azure: "f0ffff",
            beige: "f5f5dc",
            bisque: "ffe4c4",
            black: "000",
            blanchedalmond: "ffebcd",
            blue: "00f",
            blueviolet: "8a2be2",
            brown: "a52a2a",
            burlywood: "deb887",
            burntsienna: "ea7e5d",
            cadetblue: "5f9ea0",
            chartreuse: "7fff00",
            chocolate: "d2691e",
            coral: "ff7f50",
            cornflowerblue: "6495ed",
            cornsilk: "fff8dc",
            crimson: "dc143c",
            cyan: "0ff",
            darkblue: "00008b",
            darkcyan: "008b8b",
            darkgoldenrod: "b8860b",
            darkgray: "a9a9a9",
            darkgreen: "006400",
            darkgrey: "a9a9a9",
            darkkhaki: "bdb76b",
            darkmagenta: "8b008b",
            darkolivegreen: "556b2f",
            darkorange: "ff8c00",
            darkorchid: "9932cc",
            darkred: "8b0000",
            darksalmon: "e9967a",
            darkseagreen: "8fbc8f",
            darkslateblue: "483d8b",
            darkslategray: "2f4f4f",
            darkslategrey: "2f4f4f",
            darkturquoise: "00ced1",
            darkviolet: "9400d3",
            deeppink: "ff1493",
            deepskyblue: "00bfff",
            dimgray: "696969",
            dimgrey: "696969",
            dodgerblue: "1e90ff",
            firebrick: "b22222",
            floralwhite: "fffaf0",
            forestgreen: "228b22",
            fuchsia: "f0f",
            gainsboro: "dcdcdc",
            ghostwhite: "f8f8ff",
            gold: "ffd700",
            goldenrod: "daa520",
            gray: "808080",
            green: "008000",
            greenyellow: "adff2f",
            grey: "808080",
            honeydew: "f0fff0",
            hotpink: "ff69b4",
            indianred: "cd5c5c",
            indigo: "4b0082",
            ivory: "fffff0",
            khaki: "f0e68c",
            lavender: "e6e6fa",
            lavenderblush: "fff0f5",
            lawngreen: "7cfc00",
            lemonchiffon: "fffacd",
            lightblue: "add8e6",
            lightcoral: "f08080",
            lightcyan: "e0ffff",
            lightgoldenrodyellow: "fafad2",
            lightgray: "d3d3d3",
            lightgreen: "90ee90",
            lightgrey: "d3d3d3",
            lightpink: "ffb6c1",
            lightsalmon: "ffa07a",
            lightseagreen: "20b2aa",
            lightskyblue: "87cefa",
            lightslategray: "789",
            lightslategrey: "789",
            lightsteelblue: "b0c4de",
            lightyellow: "ffffe0",
            lime: "0f0",
            limegreen: "32cd32",
            linen: "faf0e6",
            magenta: "f0f",
            maroon: "800000",
            mediumaquamarine: "66cdaa",
            mediumblue: "0000cd",
            mediumorchid: "ba55d3",
            mediumpurple: "9370db",
            mediumseagreen: "3cb371",
            mediumslateblue: "7b68ee",
            mediumspringgreen: "00fa9a",
            mediumturquoise: "48d1cc",
            mediumvioletred: "c71585",
            midnightblue: "191970",
            mintcream: "f5fffa",
            mistyrose: "ffe4e1",
            moccasin: "ffe4b5",
            navajowhite: "ffdead",
            navy: "000080",
            oldlace: "fdf5e6",
            olive: "808000",
            olivedrab: "6b8e23",
            orange: "ffa500",
            orangered: "ff4500",
            orchid: "da70d6",
            palegoldenrod: "eee8aa",
            palegreen: "98fb98",
            paleturquoise: "afeeee",
            palevioletred: "db7093",
            papayawhip: "ffefd5",
            peachpuff: "ffdab9",
            peru: "cd853f",
            pink: "ffc0cb",
            plum: "dda0dd",
            powderblue: "b0e0e6",
            purple: "800080",
            rebeccapurple: "663399",
            red: "f00",
            rosybrown: "bc8f8f",
            royalblue: "4169e1",
            saddlebrown: "8b4513",
            salmon: "fa8072",
            sandybrown: "f4a460",
            seagreen: "2e8b57",
            seashell: "fff5ee",
            sienna: "a0522d",
            silver: "c0c0c0",
            skyblue: "87ceeb",
            slateblue: "6a5acd",
            slategray: "708090",
            slategrey: "708090",
            snow: "fffafa",
            springgreen: "00ff7f",
            steelblue: "4682b4",
            tan: "d2b48c",
            teal: "008080",
            thistle: "d8bfd8",
            tomato: "ff6347",
            turquoise: "40e0d0",
            violet: "ee82ee",
            wheat: "f5deb3",
            white: "fff",
            whitesmoke: "f5f5f5",
            yellow: "ff0",
            yellowgreen: "9acd32"
        };
        // Make it easy to access colors via `hexNames[hex]`
        Color.hexNames = Color.flip(Color.names);
        Color.matchers = (function () {
            // <http://www.w3.org/TR/css3-values/#integers>
            var CSS_INTEGER = "[-\\+]?\\d+%?";
            // <http://www.w3.org/TR/css3-values/#number-value>
            var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
            // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
            var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
            // Actual matching.
            // Parentheses and commas are optional, but not required.
            // Whitespace can take the place of commas or opening paren        
            var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" +
                CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
            var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" +
                CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
            return {
                rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
                rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
                hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
                hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
                hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
                hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
                hex3: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
                hex6: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
                hex8: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
            };
        })();
        return Color;
    }());

    var SNAP_VERSION = 2;
    (function (keyboard) {
        keyboard[keyboard["backspace"] = 8] = "backspace";
        keyboard[keyboard["tab"] = 9] = "tab";
        keyboard[keyboard["enter"] = 13] = "enter";
        keyboard[keyboard["shift"] = 16] = "shift";
        keyboard[keyboard["ctrl"] = 17] = "ctrl";
        keyboard[keyboard["alt"] = 18] = "alt";
        keyboard[keyboard["pause"] = 19] = "pause";
        keyboard[keyboard["capslock"] = 20] = "capslock";
        keyboard[keyboard["escape"] = 27] = "escape";
        keyboard[keyboard["pageup"] = 33] = "pageup";
        keyboard[keyboard["pagedown"] = 34] = "pagedown";
        keyboard[keyboard["end"] = 35] = "end";
        keyboard[keyboard["home"] = 36] = "home";
        keyboard[keyboard["left"] = 37] = "left";
        keyboard[keyboard["up"] = 38] = "up";
        keyboard[keyboard["right"] = 39] = "right";
        keyboard[keyboard["down"] = 40] = "down";
        keyboard[keyboard["insert"] = 45] = "insert";
        keyboard[keyboard["deleter"] = 46] = "deleter";
        keyboard[keyboard["space"] = 32] = "space";
        keyboard[keyboard["comma"] = 188] = "comma";
    })(exports.keyboard || (exports.keyboard = {}));
    (function (events) {
        events["loginRequested"] = "loginRequested";
        events["loginSuccessful"] = "loginSuccessful";
        events["logout"] = "logout";
        events["avatarChanged"] = "avatarChanged";
        events["permissionDenied"] = "permissionDenied";
    })(exports.events || (exports.events = {}));
    (function (extensions) {
        extensions["image"] = "jpg,png,gif,bmp";
        extensions["video"] = "mp4,webm,ogg,ogv";
        extensions["environments"] = "env,dds,hdr";
    })(exports.extensions || (exports.extensions = {}));
    var currencies = {
        USD: "$",
        EUR: "\u20ac",
        GBP: "\u00a3",
        AUD: "$",
        CAD: "$",
        JPY: "\u00a5"
    };
    (function (eDateUnit) {
        eDateUnit["seconds"] = "Seconds";
        eDateUnit["minutes"] = "Minutes";
        eDateUnit["hours"] = "Hours";
        eDateUnit["date"] = "Date";
        eDateUnit["month"] = "Month";
        eDateUnit["fullYear"] = "FullYear";
    })(exports.eDateUnit || (exports.eDateUnit = {}));
    (function (icons) {
        icons["error"] = "\uE197";
        icons["childError"] = "\uE220";
        icons["cancel"] = "\uE193";
        icons["save"] = "\uE444";
        icons["add"] = "\uE433";
        icons["minus"] = "\uE434";
        icons["deleter"] = "\uE017";
        icons["paste"] = "\uE513";
        icons["anonymize"] = "\uE521";
        icons["edit"] = "\uE151";
        icons["hamburger"] = "\uE159";
        icons["change"] = "\uE081";
        icons["help"] = "\uE195";
        icons["info"] = "\uE196";
        icons["infoCircle"] = "\uE196";
        icons["success"] = "\uE194";
        icons["folder"] = "\uE145";
        icons["upload"] = "\uE364";
        icons["download"] = "\uE365";
        icons["refresh"] = "\uE082";
        icons["rename"] = "\uE081";
        icons["crumb"] = "\uE224";
        icons["image"] = "\uE139";
        icons["addFolder"] = "\uE146";
        icons["open"] = "\uE145";
        icons["localization"] = "\uE372";
        icons["camera"] = "\uE012";
        icons["user"] = "\uE004";
        icons["users"] = "\uE044";
        icons["quote"] = "\uE203";
        icons["products"] = "\uE157";
        icons["standardProducts"] = "\uE156";
        icons["company"] = "\uE090";
        icons["gear"] = "\uE137";
        icons["gears"] = "\uE138";
        icons["role"] = "\uE089";
        icons["roles"] = "\uE089";
        icons["theme"] = "\uE190";
        icons["queue"] = "\uE114";
        icons["builder"] = "\uE364";
        icons["tag"] = "\uE066";
        icons["tags"] = "\uE067";
        icons["comment"] = "\uE310";
        icons["attachment"] = "\uE063";
        icons["rule"] = "\uE731";
        icons["popout"] = "\uE390";
        icons["popin"] = "\uE215";
        icons["play"] = "\uE174";
        icons["list"] = "\uE115";
        icons["tile"] = "\uE157";
        icons["search"] = "\uE028";
        icons["earth"] = "\uE371";
        icons["flag"] = "\uE267";
        icons["mail"] = "\uE128";
        icons["all"] = "\uE114";
        icons["clear"] = "\uE208";
        icons["dollar"] = "\uE228";
        icons["template"] = "\uE685";
        icons["templates"] = "\uE120";
        icons["up"] = "\uE214";
        icons["down"] = "\uE213";
        icons["right"] = "\uE212";
        icons["left"] = "\uE211";
        icons["infrastructure"] = "\uE281";
        icons["database"] = "\uE141";
        icons["integrations"] = "\uE490";
        icons["workflowSelector"] = "\uE428";
        icons["tools"] = "\uE281";
        icons["settings"] = "\uE140";
        icons["permission"] = "\uE271";
        icons["workflow"] = "\uE309";
        icons["email"] = "\uE125";
        icons["approve"] = "\uE199";
        icons["reject"] = "\uE198";
        icons["shipping"] = "\uE059";
        icons["logout"] = "\uE388";
        icons["deploy"] = "\uE458";
        icons["globe"] = "\uE341";
        icons["generators"] = "\uE260";
        icons["generator"] = "\uE260";
        icons["resources"] = "\uE343";
        icons["output"] = "\uE360";
        icons["cleanworkspace"] = "\uE068";
        icons["undo"] = "\uE222";
        icons["redo"] = "\uE223";
        icons["bold"] = "\uE103";
        icons["italic"] = "\uE102";
        icons["heading"] = "\uE460";
        icons["link"] = "\uE051";
        icons["img"] = "\uE139";
        icons["capture"] = "\uE010";
        icons["submit"] = "\uE224";
        icons["discount"] = "\uE228";
        icons["log"] = "\uE088";
        icons["zoomIn"] = "\uE237";
        icons["zoomOut"] = "\uE238";
        icons["visible"] = "\uE052";
        icons["notVisible"] = "\uE053";
        icons["table"] = "\uE120";
        icons["chevronLeft"] = "\uE225";
        icons["chevronRight"] = "\uE224";
        icons["chevronUp"] = "\uE601";
        icons["chevronDown"] = "\uE602";
        icons["fullscreen"] = "\uE216";
        icons["exitFullscreen"] = "\uE215";
        icons["vr"] = "\uE783";
        icons["clone"] = "\uE511";
        icons["hand"] = "\uE348";
        icons["embed"] = "\uE118";
        icons["safeFunction"] = "\uE221";
        icons["function"] = "\uE206";
        icons["globalDefinition"] = "\uE732";
        icons["reference"] = "\uE423";
        icons["more"] = "\uE188";
        icons["plus"] = "\uE191";
        icons["removed"] = "\uE192";
        icons["test"] = "\uE534";
        icons["name"] = "\uE607";
        icons["cloud"] = "\uE233";
        icons["filter"] = "\uE321";
        icons["warning"] = "\uE079";
        icons["hotspot"] = "\uE186";
        icons["threeD"] = "\uE780";
        icons["cube"] = "\uE779";
        icons["column"] = "\uE539";
        icons["report"] = "\uE042";
        icons["lock"] = "\uE204";
        icons["layout"] = "\uE164";
        icons["layoutConfig"] = "\uE164";
        icons["channels"] = "\uE353";
        icons["history"] = "\uE058";
        icons["view"] = "\uE052";
        icons["automationStudio"] = "\uE508";
        icons["complete"] = "\uE194";
        icons["generating"] = "\uE137";
        icons["failed"] = "\uE197";
        icons["cast"] = "\uE458";
        icons["setVar"] = "\uE212";
        icons["getVar"] = "\uE211";
        icons["alignVertical"] = "\uE655";
        icons["alignRight"] = "\uE656";
        icons["alignLeft"] = "\uE654";
        icons["alignTop"] = "\uE651";
        icons["alignBottom"] = "\uE652";
        icons["alignHorizontal"] = "\uE653";
        icons["shrink"] = "\uE487";
        icons["stretch"] = "\uE488";
        icons["centerText"] = "\uE112";
        icons["leftText"] = "\uE111";
        icons["rightText"] = "\uE113";
        icons["justifyText"] = "\uE114";
        icons["leftIndent"] = "\uE109";
        icons["rightIndent"] = "\uE110";
        icons["rotateRight"] = "\uE736";
        icons["rotateLeft"] = "\uE737";
        // configurator types
        icons["actionBar"] = "\uE158";
        icons["configurator"] = "\uE157";
        icons["page"] = "\uE037";
        icons["group"] = "\uE530";
        icons["ruleContainer"] = "\uE145";
        icons["pricingRuleContainer"] = "\uE228";
        icons["action"] = "\uE221";
        icons["builds"] = "\uE138";
        icons["build"] = "\uE137";
        icons["tabControl"] = "\u25F0";
        icons["tab"] = "\u25F3";
        icons["gridRow"] = "\u25A4";
        icons["gridColumn"] = "\u25A5";
        icons["accordion"] = "\uE114";
        icons["expander"] = "\uE728";
        icons["button"] = "\uE221";
        icons["toolbar"] = "\uE158";
        icons["popup"] = "\uE151";
        icons["dropdownButton"] = "\uE782";
        icons["content"] = "\uE154";
        icons["priceWidget"] = "\uE228";
        icons["pageControl"] = "\uE319";
        icons["viewer"] = "\uE779";
        icons["canvas"] = "\uE287";
        icons["container"] = "\uE095";
        icons["pageNavigator"] = "\uE458";
        icons["pageTabs"] = "\u25F0";
        icons["nestedSet"] = "\uE156";
        // controls
        icons["textbox"] = "\uE108";
        icons["numberbox"] = "#";
        icons["checkbox"] = "\uE153";
        icons["select"] = "\uE368";
        icons["none"] = "\uE200";
        icons["colorPicker"] = "\uE091";
        icons["colorSelect"] = "\uE328";
        icons["slider"] = "\uE216";
        icons["multilineTextbox"] = "\uE111";
        icons["label"] = "L";
        icons["imageSelect"] = "\uE139";
        icons["imageMultiSelect"] = "\uE139";
        icons["autoComplete"] = "\uE028";
        icons["media"] = "\uE012";
        icons["mediaPicker"] = "\uE012";
        icons["html"] = "\uE119";
        icons["datePicker"] = "\uE046";
        icons["swatchSelect"] = "\uE328";
        icons["multiSelect"] = "\uE368";
        icons["colorMultiSelect"] = "\uE328";
        icons["toggle"] = "\uE394";
        icons["radio"] = "\uE170";
        icons["svgViewer"] = "\uE100";
        // column types
        icons["text"] = "\uE108";
        icons["number"] = "\uE228";
        icons["boolean"] = "\uE153";
        icons["color"] = "\uE091";
        icons["date"] = "\uE046";
        // localized = "",
        icons["manufacture"] = "\uE461";
        icons["material"] = "\uE287";
        icons["operation"] = "\uE440";
        icons["opdetail"] = "\uE541";
        icons["outputFieldDefault"] = "\uE154";
        icons["outputFieldWordList"] = "\uE158";
        icons["outputFieldWordText"] = "\uE108";
        icons["outputFieldWordImage"] = "\uE139";
        icons["outputFieldWordContainer"] = "\uE154";
        icons["outputFieldCadAnnotation"] = "\uE108";
        icons["outputFieldCadDimension"] = "\uE069";
        icons["outputFieldCadDynamicComponent"] = "\uE049";
        icons["outputFieldMate"] = "\uE024";
        icons["outputFieldCustomProperty"] = "\uE040";
        icons["outputFieldCadComponent"] = "\uE779";
        icons["kbmaxNotifications"] = "\uE130";
        icons["send"] = "\uE422";
    })(exports.icons || (exports.icons = {}));

    // tslint:disable
    String.prototype.replaceAll = function (find, replace) {
        return this.replace(new RegExp(find, 'g'), replace);
    };
    String.prototype.format = function () {
        var texts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            texts[_i] = arguments[_i];
        }
        return this.replace(/\{\{|\}\}|\{(\d+)\}/g, function (m, n) {
            if (m == "{{") {
                return "{";
            }
            if (m == "}}") {
                return "}";
            }
            return texts[n];
        });
    };
    String.prototype.toCamelCase = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toLowerCase() + txt.substr(1); });
    };
    String.prototype.toPascalCase = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1); });
    };
    String.prototype.capitalize = function () {
        return this.charAt(0).toUpperCase() + this.slice(1);
    };
    var kebabCaseRegex = /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g;
    String.prototype.toKebabCase = function () {
        return this.match(kebabCaseRegex)
            .map(function (x) { return x.toLowerCase(); })
            .join('-');
    };
    String.prototype.toSentence = function () {
        return this.replace(/([A-Z])/g, ' $1') // insert a space before all caps            
            .replace(/^./, function (str) { return str.toUpperCase(); }); // uppercase the first character
    };
    String.prototype.removeSpaces = function () {
        return this.replace(/\s+/g, '');
    };
    String.prototype.addSlashes = function () {
        return this.replace(/\\/g, '\\\\').
            //replace(/\u0008/g, '\\b').
            replace(/\t/g, '\\t').
            replace(/\n/g, '\\n').
            replace(/\f/g, '\\f').
            replace(/\r/g, '\\r').
            replace(/'/g, '\\\'').
            replace(/"/g, '\\"');
    };
    String.prototype.isEqual = function (str) {
        return (this ? this.toUpperCase() : undefined) === (str ? str.toUpperCase() : undefined);
    };
    String.prototype.equalsAny = function () {
        var _this = this;
        var strings = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            strings[_i] = arguments[_i];
        }
        return strings && strings.some(function (s) { return s.isEqual(_this); });
    };
    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (searchString, position) {
            var subjectString = this.toString();
            if (position === undefined || position > subjectString.length) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.indexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        };
    }
    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }
    if (!String.prototype.repeat) {
        String.prototype.repeat = function (count) {
            if (this == null) {
                throw new TypeError('can\'t convert ' + this + ' to object');
            }
            var str = '' + this;
            count = +count;
            if (count != count) {
                count = 0;
            }
            if (count < 0) {
                throw new RangeError('repeat count must be non-negative');
            }
            if (count == Infinity) {
                throw new RangeError('repeat count must be less than infinity');
            }
            count = Math.floor(count);
            if (str.length == 0 || count == 0) {
                return '';
            }
            // Ensuring count is a 31-bit integer allows us to heavily optimize the
            // main part. But anyway, most current (August 2014) browsers can't handle
            // strings 1 << 28 chars or longer, so:
            if (str.length * count >= 1 << 28) {
                throw new RangeError('repeat count must not overflow maximum string size');
            }
            var maxCount = str.length * count;
            count = Math.floor(Math.log(count) / Math.log(2));
            while (count) {
                str += str;
                count--;
            }
            str += str.substring(0, maxCount - str.length);
            return str;
        };
    }
    Number.prototype.rounder = function (precision) {
        var num = this.stripScientificNotation();
        return +(Math.round(+(num + 'e' + precision)) + 'e-' + precision);
    };
    /**
     * Converts scientific notation to decimal or big number string.
     */
    Number.prototype.stripScientificNotation = function () {
        var strNum = this.toString();
        if (strNum.indexOf("e") === -1)
            return strNum;
        var strNumArr = strNum.split("e");
        if (strNumArr.length === 2) {
            var formattedNum = strNumArr[0].replace(".", "");
            var numZeros = void 0;
            if (strNumArr[1].charAt(0) === "-") {
                var isNegative = strNumArr[0].charAt(0) === "-";
                if (isNegative) {
                    formattedNum = formattedNum.substr(1);
                }
                numZeros = parseInt(strNumArr[1].substr(1), 10) - 1;
                if (numZeros > 50)
                    return "0"; //Let's not bother with extremely small numbers
                for (var i = 0; i < numZeros; i++) {
                    formattedNum = "0" + formattedNum;
                }
                formattedNum = "0." + formattedNum;
                if (isNegative) {
                    formattedNum = "-" + formattedNum;
                }
            }
            else {
                // Then maybe a very large number, ex: 5.302923e+22
                numZeros = parseInt(strNumArr[1].substr(1), 10) - (formattedNum.length - 1);
                if (numZeros > 50)
                    return "Infinity"; //Let's not bother with extremely large numbers
                for (var i = 0; i < numZeros; i++) {
                    formattedNum += "0";
                }
            }
            return formattedNum;
        }
        return "0";
    };
    /**
     * formats a number given different formatting options
     */
    Number.prototype.format = function (args) {
        var pattern;
        var t = args.thousandsSeparator;
        var d = args.decimalSeparator || ".";
        var type = args.formatType;
        var currency = args.currency || "USD";
        var minPrecision = isNaN(args.minPrecision) ? 0 : args.minPrecision;
        var maxPrecision = isNaN(args.maxPrecision) ? 0 : args.maxPrecision;
        maxPrecision = maxPrecision < minPrecision ? minPrecision : maxPrecision;
        var prefix = args.prefix || "";
        var suffix = args.suffix || "";
        //for currency, we should always have a thousands separator
        if (type === "currency") {
            t = t || ",";
        }
        if (type === "number" || type === "currency" || type === "percentage") {
            pattern = "#" + t + "##0" + d + Array(minPrecision + 1).join("0") + Array(maxPrecision - minPrecision + 1).join("#");
        }
        var v = this.formatNumber(pattern);
        if (type === "currency") {
            // Not sure why it's not picking up the currencies declaration in icons
            var symbol = currencies[args.currency] || "";
            v = symbol + v + " " + args.currency;
        }
        if (type === "percentage") {
            v += "%";
        }
        return prefix + v + suffix;
    };
    /**
     * formats a number using a pattern: see here for documentation: https://code.google.com/p/javascript-number-formatter/
     */
    Number.prototype.formatNumber = function (pattern) {
        var m = pattern;
        var v = this;
        var num = v;
        // Make sure it's not in scientific notation
        // (Javascript switches automatically when you get to 7 decimal places)
        if (num < 1e-6)
            v = num.stripScientificNotation();
        if (!m || isNaN(+v)) {
            return v; //return as it is.
        }
        //convert any string to number according to formation sign.
        v = m.charAt(0) == '-' ? -v : +v;
        var isNegative = v < 0 ? v = -v : 0; //process only abs(), and turn on flag.
        //search for separator for grp & decimal, anything not digit, not +/- sign, not #.
        var result = m.match(/[^\d\-\+#]/g);
        var Decimal = (result && result[result.length - 1]) || '.'; //treat the right most symbol as decimal 
        var Group = (result && result[1] && result[0]) || ','; //treat the left most symbol as group separator
        //split the decimal for the format string if any.
        var m = m.split(Decimal);
        //Fix the decimal first, toFixed will auto fill trailing zero.
        v = v.toFixed(m[1] && m[1].length);
        v = +(v) + ''; //convert number to string to trim off *all* trailing decimal zero(es)
        //fill back any trailing zero according to format
        var pos_trail_zero = m[1] && m[1].lastIndexOf('0'); //look for last zero in format
        var part = v.split('.');
        //integer will get !part[1]
        if (!part[1] || part[1] && part[1].length <= pos_trail_zero) {
            v = (+v).toFixed(pos_trail_zero + 1);
        }
        var szSep = m[0].split(Group); //look for separator
        m[0] = szSep.join(''); //join back without separator for counting the pos of any leading 0.
        var pos_lead_zero = m[0] && m[0].indexOf('0');
        if (pos_lead_zero > -1) {
            while (part[0].length < (m[0].length - pos_lead_zero)) {
                part[0] = '0' + part[0];
            }
        }
        else if (+part[0] == 0) {
            part[0] = '';
        }
        v = v.split('.');
        v[0] = part[0];
        //process the first group separator from decimal (.) only, the rest ignore.
        //get the length of the last slice of split result.
        var pos_separator = (szSep[1] && szSep[szSep.length - 1].length);
        if (pos_separator) {
            var integer = v[0];
            var str = '';
            var offset = integer.length % pos_separator;
            for (var i = 0, l = integer.length; i < l; i++) {
                str += integer.charAt(i); //ie6 only support charAt for sz.
                //-pos_separator so that won't trail separator on full length
                if (!((i - offset + 1) % pos_separator) && i < l - pos_separator) {
                    str += Group;
                }
            }
            v[0] = str;
        }
        v[1] = (m[1] && v[1]) ? Decimal + v[1] : "";
        return (isNegative ? '-' : '') + v[0] + v[1]; //put back any negation and combine integer and fraction.
    };
    Object.defineProperty(Array.prototype, "clear", {
        enumerable: false,
        writable: true,
        value: function () {
            this.length = 0;
        }
    });
    //Array.prototype.clear = function (): void {
    //    this.length = 0;
    //}
    Object.defineProperty(Array.prototype, "remove", {
        enumerable: false,
        writable: true,
        value: function (item) {
            var index = this.indexOf(item);
            if (index != -1) {
                return this.splice(this.indexOf(item), 1);
            }
        }
    });
    //Array.prototype.remove = function (item: any): Array<any> {
    //    var index = this.indexOf(item);
    //    if (index != -1) {
    //        return this.splice(this.indexOf(item), 1);
    //    }
    //}
    Object.defineProperty(Array.prototype, "removeWhere", {
        enumerable: false,
        writable: true,
        value: function (predicate) {
            var removed = [];
            for (var i = this.length - 1; i >= 0; i--) {
                var item = this[i];
                if (predicate(item)) {
                    removed.pushArray(this.splice(i, 1));
                }
            }
            return removed;
        }
    });
    //Array.prototype.removeWhere = function(predicate) {
    //    for (var i = this.length - 1; i >= 0; i--) {
    //        var item = this[i];
    //        if (predicate(item)) {
    //            this.splice(i, 1);
    //        }
    //    }
    //}
    Object.defineProperty(Array.prototype, "move", {
        enumerable: false,
        writable: true,
        value: function (fromIndex, toIndex) {
            if (toIndex >= this.length) {
                var k = toIndex - this.length;
                while ((k--) + 1) {
                    this.push(undefined);
                }
            }
            this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
            return this; // for testing purposes
        }
    });
    //Array.prototype.move = function (fromIndex, toIndex) {
    //    if (toIndex >= this.length) {
    //        var k = toIndex - this.length;
    //        while ((k--) + 1) {
    //            this.push(undefined);
    //        }
    //    }
    //    this.splice(toIndex, 0, this.splice(fromIndex, 1)[0]);
    //    return this; // for testing purposes
    //};
    Object.defineProperty(Array.prototype, "contains", {
        enumerable: false,
        writable: true,
        value: function (item) {
            var index = this.indexOf(item);
            return (index != -1);
        }
    });
    //Array.prototype.contains = function (item: any): boolean {
    //    var index = this.indexOf(item);
    //    return (index != -1);
    //}
    Object.defineProperty(Array.prototype, "pushArray", {
        enumerable: false,
        writable: true,
        value: function (items) {
            this.push.apply(this, items);
        }
    });
    //Array.prototype.pushArray = function (items: any[]): void {
    //    this.push.apply(this, items);
    //}
    Object.defineProperty(Array.prototype, "pushIf", {
        enumerable: false,
        writable: true,
        value: function (condition) {
            var items = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                items[_i - 1] = arguments[_i];
            }
            if (condition)
                this.push.apply(this, items);
            return this;
        }
    });
    Object.defineProperty(Array.prototype, "equals", {
        enumerable: false,
        writable: true,
        value: function (b) {
            if (this === b)
                return true;
            if (b == null)
                return false;
            if (this.length != b.length)
                return false;
            // If you don't care about the order of the elements inside
            // the array, you should sort both arrays here.
            for (var i = 0; i < this.length; ++i) {
                if (this[i] !== b[i])
                    return false;
            }
            return true;
        }
    });
    if (!Array.prototype.find) {
        Object.defineProperty(Array.prototype, "find", {
            enumerable: false,
            writable: true,
            value: function (predicate) {
                if (this == null) {
                    throw new TypeError('Array.prototype.find called on null or undefined');
                }
                if (typeof predicate !== 'function') {
                    throw new TypeError('predicate must be a function');
                }
                var list = Object(this);
                var length = list.length >>> 0;
                var thisArg = arguments[1];
                var value;
                for (var i = 0; i < length; i++) {
                    value = list[i];
                    if (predicate.call(thisArg, value, i, list)) {
                        return value;
                    }
                }
                return undefined;
            }
        });
    }
    Object.defineProperty(Array.prototype, "getDefinedLength", {
        enumerable: false,
        writable: true,
        value: function () {
            var result = 0;
            for (var i = 0; i < this.length; i++) {
                if (this[i] !== undefined)
                    result++;
            }
            return result;
        }
    });
    Object.defineProperty(Array.prototype, "first", {
        enumerable: false,
        writable: true,
        value: function () {
            var item;
            if (this.length) {
                item = this[0];
            }
            return item;
        }
    });
    Object.defineProperty(Array.prototype, "last", {
        enumerable: false,
        writable: true,
        value: function () {
            if (this.length) {
                return this[this.length - 1];
            }
            return undefined;
        }
    });
    Object.defineProperty(Array.prototype, "next", {
        enumerable: false,
        writable: true,
        value: function (item, predicate) {
            var next;
            var i = this.indexOf(item);
            if (i >= -1 && i < this.length - 1) {
                if (predicate) {
                    for (var n = i + 1; n < this.length; n++) {
                        if (predicate(this[n])) {
                            next = this[n];
                            break;
                        }
                    }
                }
                else {
                    next = this[i + 1];
                }
            }
            return next;
        }
    });
    Object.defineProperty(Array.prototype, "previous", {
        enumerable: false,
        writable: true,
        value: function (item, predicate) {
            var prev;
            var i = this.indexOf(item);
            if (i == -1)
                i = this.length;
            if (i > 0 && i <= this.length) {
                if (predicate) {
                    for (var n = i - 1; n >= 0; n--) {
                        if (predicate(this[n])) {
                            prev = this[n];
                            break;
                        }
                    }
                }
                else {
                    prev = this[i - 1];
                }
            }
            return prev;
        }
    });
    Object.defineProperty(Array.prototype, "removeNulls", {
        enumerable: false,
        writable: true,
        value: function () {
            return this.filter(function (x) {
                return x !== null && x !== undefined;
            });
        }
    });
    Object.defineProperty(Array.prototype, "sortBy", {
        enumerable: false,
        writable: true,
        value: function (predicate) {
            return this.sort(function (a, b) {
                if (predicate(a) < predicate(b)) {
                    return -1;
                }
                else if (predicate(a) > predicate(b)) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        }
    });
    Object.defineProperty(Array.prototype, "sortByDescending", {
        enumerable: false,
        writable: true,
        value: function (predicate) {
            return this.sort(function (a, b) {
                if (predicate(a) > predicate(b)) {
                    return -1;
                }
                else if (predicate(a) < predicate(b)) {
                    return 1;
                }
                else {
                    return 0;
                }
            });
        }
    });
    if (!Array.prototype.fill) {
        Object.defineProperty(Array.prototype, "fill", {
            enumerable: false,
            writable: true,
            value: function (value) {
                // Steps 1-2.
                if (this == null) {
                    throw new TypeError('this is null or not defined');
                }
                var O = Object(this);
                // Steps 3-5.
                var len = O.length >>> 0;
                // Steps 6-7.
                var start = arguments[1];
                var relativeStart = start >> 0;
                // Step 8.
                var k = relativeStart < 0 ?
                    Math.max(len + relativeStart, 0) :
                    Math.min(relativeStart, len);
                // Steps 9-10.
                var end = arguments[2];
                var relativeEnd = end === undefined ?
                    len : end >> 0;
                // Step 11.
                var final = relativeEnd < 0 ?
                    Math.max(len + relativeEnd, 0) :
                    Math.min(relativeEnd, len);
                // Step 12.
                while (k < final) {
                    O[k] = value;
                    k++;
                }
                // Step 13.
                return O;
            }
        });
    }
    Object.defineProperty(Array.prototype, "unique", {
        enumerable: false,
        writable: true,
        value: function (selector) {
            var u = {}, a = [];
            for (var i = 0, l = this.length; i < l; ++i) {
                var val = this[i];
                if (selector)
                    val = selector(val);
                if (u.hasOwnProperty(val)) {
                    continue;
                }
                a.push(this[i]);
                u[val] = 1;
            }
            return a;
        }
    });
    Object.defineProperty(Array.prototype, "top", {
        enumerable: false,
        writable: true,
        value: function (n, predicate) {
            if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var length = this.length;
            var thisArg = arguments[1];
            var value;
            var matches = [];
            for (var i = 0; i < length; i++) {
                value = this[i];
                if (predicate.call(thisArg, value, i)) {
                    matches.push(value);
                    if (matches.length >= n) {
                        return matches;
                    }
                }
            }
            return matches;
        }
    });
    Object.defineProperty(Array.prototype, "innerJoin", {
        enumerable: false,
        writable: true,
        value: function (otherArr, keySelector, otherKeySelector) {
            return ArrayExt.innerJoin(this, otherArr, keySelector, otherKeySelector);
        }
    });
    Object.defineProperty(Array.prototype, "leftJoin", {
        enumerable: false,
        writable: true,
        value: function (otherArr, keySelector, otherKeySelector) {
            return ArrayExt.leftJoin(this, otherArr, keySelector, otherKeySelector);
        }
    });
    Object.defineProperty(Array.prototype, "rightJoin", {
        enumerable: false,
        writable: true,
        value: function (otherArr, keySelector, otherKeySelector) {
            return ArrayExt.leftJoin(otherArr, this, keySelector, otherKeySelector);
        }
    });
    Object.defineProperty(Array.prototype, "fullOuterJoin", {
        enumerable: false,
        writable: true,
        value: function (otherArr, keySelector, otherKeySelector) {
            return ArrayExt.fullOuterJoin(otherArr, this, keySelector, otherKeySelector);
        }
    });
    Object.defineProperty(Array.prototype, "recurse", {
        enumerable: false,
        writable: true,
        value: function (childSelector, action) {
            for (var i = 0; i < this.length; i++) {
                action(this[i]);
                var childArr = childSelector(this[i]);
                if (childArr) {
                    childArr.recurse(childSelector, action);
                }
            }
        }
    });
    Object.defineProperty(Array.prototype, "selectMany", {
        enumerable: false,
        writable: true,
        value: function (selector) {
            return this.reduce(function (out, v) {
                var vres = selector(v);
                if (vres != null) {
                    if (!Array.isArray(vres))
                        vres = [vres];
                    out.push.apply(out, vres);
                }
                return out;
            }, []);
        }
    });
    var ArrayExt = /** @class */ (function () {
        function ArrayExt() {
        }
        ArrayExt.innerJoin = function (thisArr, otherArr, keySelector, otherKeySelector) {
            var arrSmall;
            var dbBig = {}; //dictionary of the bigger array indexed by key
            var smallKeySelector;
            if (thisArr.length <= otherArr.length) {
                arrSmall = thisArr;
                smallKeySelector = keySelector;
                //fill in the big db
                otherArr.forEach(function (i) {
                    var key = otherKeySelector(i);
                    dbBig[key] = dbBig[key] || [];
                    dbBig[key].push(i);
                });
            }
            else {
                arrSmall = otherArr;
                smallKeySelector = otherKeySelector;
                //fill in the big db
                thisArr.forEach(function (i) {
                    var key = keySelector(i);
                    dbBig[key] = dbBig[key] || [];
                    dbBig[key].push(i);
                });
            }
            var result = [];
            arrSmall.forEach(function (item) {
                var key = smallKeySelector(item);
                if (dbBig.hasOwnProperty(key)) {
                    dbBig[key].forEach(function (i) {
                        //create a new object to leave the source arrays as is
                        result.push(Object.assign({}, item, i));
                    });
                }
            });
            return result;
        };
        ArrayExt.leftJoin = function (thisArr, otherArr, keySelector, otherKeySelector) {
            var dbOther = {};
            otherArr.forEach(function (i) {
                var key = otherKeySelector(i);
                dbOther[key] = dbOther[key] || [];
                dbOther[key].push(i);
            });
            var result = [];
            thisArr.forEach(function (item) {
                var key = keySelector(item);
                if (dbOther[key]) {
                    dbOther[key].forEach(function (i) {
                        //create a new object to leave the source arrays as is
                        result.push(Object.assign({}, item, i));
                    });
                }
                else {
                    result.push(Object.assign({}, item));
                }
            });
            return result;
        };
        ArrayExt.fullOuterJoin = function (thisArr, otherArr, keySelector, otherKeySelector) {
            var arrSmall;
            var dbBig = {}; //dictionary of the bigger array indexed by key
            var smallKeySelector;
            if (thisArr.length <= otherArr.length) {
                arrSmall = thisArr;
                smallKeySelector = keySelector;
                //fill in the big db
                otherArr.forEach(function (i) {
                    var key = otherKeySelector(i);
                    dbBig[key] = dbBig[key] || [];
                    dbBig[key].push(i);
                });
            }
            else {
                arrSmall = otherArr;
                smallKeySelector = otherKeySelector;
                //fill in the big db
                thisArr.forEach(function (i) {
                    var key = keySelector(i);
                    dbBig[key] = dbBig[key] || [];
                    dbBig[key].push(i);
                });
            }
            var result = [];
            arrSmall.forEach(function (item) {
                var key = smallKeySelector(item);
                if (dbBig.hasOwnProperty(key)) {
                    dbBig[key].forEach(function (i) {
                        //create a new object to leave the source arrays as is
                        result.push(Object.assign({}, item, i));
                    });
                    // Delete the item from dbBig... anything remaining in this
                    // list will be added at the end.
                    delete dbBig[key];
                }
                else {
                    // The item is not in the "big" array, but we add it to the
                    // result as part of the outer join.
                    result.push(Object.assign({}, item));
                }
            });
            // Now we just add the items left over from the big array that
            // didn't match the keys.
            for (var key in dbBig) {
                var item = dbBig[key];
                item.forEach(function (i) { return result.push(Object.assign({}, i)); });
            }
            return result;
        };
        return ArrayExt;
    }());
    Object.defineProperty(Array.prototype, "toObject", {
        enumerable: false,
        writable: true,
        value: function (keySelector) {
            return this.reduce(function (o, item) {
                o[keySelector(item)] = item;
                return o;
            }, {});
        }
    });
    Object.defineProperty(Array.prototype, "flatten", {
        enumerable: false,
        writable: true,
        value: function (childSelector) {
            var r = [];
            var f = function (item) {
                r.push(item);
                var children = childSelector(item);
                if (children) {
                    for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
                        var i = children_1[_i];
                        f(i);
                    }
                }
            };
            for (var _i = 0, _a = this; _i < _a.length; _i++) {
                var i = _a[_i];
                f(i);
            }
            return r;
        }
    });
    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (target) {
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }
                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);
                    var keysArray = Object.keys(nextSource);
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            }
        });
    }
    if (!Object.values) {
        Object.defineProperty(Object, 'values', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (o) {
                return Object.keys(o).map(function (key) { return o[key]; });
            }
        });
    }
    if (!('toJSON' in Error.prototype)) {
        Object.defineProperty(Error.prototype, 'toJSON', {
            value: function () {
                var alt = {};
                Object.getOwnPropertyNames(this).forEach(function (key) {
                    alt[key] = this[key];
                }, this);
                return alt;
            },
            configurable: true,
            writable: true
        });
    }

    var KbEvent = /** @class */ (function () {
        function KbEvent() {
            /** ordered list to hold the listeners sorted by their priority. The lower the number, the higher the priority */
            this._listeners = [];
        }
        KbEvent.prototype.add = function (callback, tag) {
            if (tag === void 0) { tag = null; }
            this._listeners.push({ callback: callback, tag: tag });
        };
        KbEvent.prototype.remove = function (callback) {
            if (typeof callback === "function") {
                for (var i = 0; i < this._listeners.length; i++) {
                    if (this._listeners[i].callback === callback) {
                        this._listeners.splice(i, 1);
                        break;
                    }
                }
            }
            else {
                this._listeners.length = 0;
            }
        };
        /*
         * removes all listeners with the given tag
         */
        KbEvent.prototype.removeByTag = function (tag) {
            for (var i = 0; i < this._listeners.length; i++) {
                if (this._listeners[i].tag === tag) {
                    this._listeners.splice(i, 1);
                }
            }
        };
        KbEvent.prototype.trigger = function (args) {
            for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
                var l = _a[_i];
                l.callback.apply(null, [args]);
            }
        };
        return KbEvent;
    }());

    var Logger = /** @class */ (function () {
        function Logger() {
        }
        Logger.logRuleStart = function (configName, ruleType) {
            if (Logger.writeRuleCycleLogs) {
                var startTime = Date.now();
                if (Logger.writeRuleCycleLogs) {
                    console.log("%cRULE -> ".concat(configName, " -> ").concat(ruleType, " -> START"), "background: rgba(0,182,255,0.3)");
                }
                return startTime;
            }
        };
        Logger.logRuleEnd = function (configName, ruleType, start) {
            if (Logger.writeRuleCycleLogs) {
                var time = Date.now() - start;
                console.log("%cRULE -> ".concat(configName, " -> ").concat(ruleType, " -> END  ").concat(time, "ms"), "background: rgba(0,85,255,0.3)");
            }
        };
        Logger.logSceneChange = function (msg) {
            if (Logger.writeSceneChangeLogs) {
                console.log(msg);
            }
        };
        Logger.writeRuleCycleLogs = false;
        Logger.writeSceneChangeLogs = false;
        return Logger;
    }());
    if (typeof window !== "undefined") {
        try {
            Logger.writeRuleCycleLogs = localStorage.getItem("writeRuleCycleLogs") == "true";
            Logger.writeSceneChangeLogs = localStorage.getItem("writeSceneChangeLogs") == "true";
        }
        catch (_a) { }
    }

    var Map = /** @class */ (function () {
        function Map() {
            this._data = [];
        }
        Map.prototype.set = function (key, value) {
            var existingValue = this.getItem(key);
            if (existingValue) {
                existingValue.value = value;
            }
            this._data.push({
                key: key,
                value: value
            });
        };
        Map.prototype.get = function (key) {
            var mapping = this.getItem(key);
            if (!mapping)
                return null;
            return mapping.value;
        };
        Map.prototype.delete = function (key) {
            this._data.removeWhere(function (d) { return d.key == key; });
        };
        Map.prototype.getItem = function (key) {
            return this._data.find(function (d) { return d.key == key; });
        };
        return Map;
    }());

    (function (eScrollMode) {
        eScrollMode[eScrollMode["nearest"] = 0] = "nearest";
        eScrollMode[eScrollMode["middleIfNecessary"] = 1] = "middleIfNecessary";
    })(exports.eScrollMode || (exports.eScrollMode = {}));
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.loadScriptAsync = function (src) {
            var deferred = Q.defer();
            var s, t;
            s = document.createElement('script');
            s.type = 'text/javascript';
            s.src = src;
            s.onload = function () {
                deferred.resolve();
            };
            t = document.getElementsByTagName('script')[0];
            t.parentNode.insertBefore(s, t);
            return deferred.promise;
        };
        Utils.replaceAll = function (str, find, replace) {
            if (str) {
                return str.replaceAll(find, replace);
            }
            return str;
        };
        Utils.scrubName = function (str) {
            if (!str)
                return "";
            return str.replace(/[^a-z0-9]/gi, "_");
        };
        Utils.guard = function (condition, failMessage) {
            if (!condition)
                throw (failMessage ? failMessage : "Guard failed");
        };
        Utils.guardNotNull = function (variable, failMessage) {
            Utils.guard(variable !== null && variable !== undefined, (failMessage ? failMessage : "Value must not be null"));
        };
        Utils.guardNotEmpty = function (variable, failMessage) {
            Utils.guard(variable !== null && variable !== undefined && variable.length > 0, (failMessage ? failMessage : "String must not be empty"));
        };
        Utils.getParameterByName = function (url, name) {
            name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
            var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
            var results = regex.exec(url);
            return results == null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
        };
        Utils.isDefined = function (o) {
            return typeof o !== "undefined";
        };
        Utils.extend = function () {
            var objects = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                objects[_i] = arguments[_i];
            }
            var o;
            if (objects && objects.length) {
                o = objects[0];
                for (var i = 1; i < objects.length; i++) {
                    var o2 = objects[i];
                    for (var prop in o2) {
                        if (o2.hasOwnProperty(prop)) {
                            o[prop] = o2[prop];
                        }
                    }
                }
            }
            return o;
        };
        Utils.getFilenameWithoutExtension = function (path) {
            var filename = path.substring(path.lastIndexOf("/") + 1);
            var sections = filename.split(".");
            return sections[0];
        };
        Utils.getExtension = function (path) {
            var a = document.createElement("a");
            a.href = path;
            // tslint:disable-next-line:no-bitwise
            return a.pathname.substr((~-a.pathname.lastIndexOf(".") >>> 0) + 2);
        };
        Utils.isAbsoluteUrl = function (url) {
            return Utils.ABS_URL_REGEX.test(url);
        };
        Utils.isGuid = function (guid) {
            return (Utils.GUID_REGEX.exec(guid) != null);
        };
        /**
         * a shorter version of a uuid that is way more unique than we need
         */
        Utils.shortId = function () {
            var x = 2147483648;
            // added the slice to get us down to 9 characters
            return Math.floor(Math.random() * x).toString(36).slice(0, 3) +
                // tslint:disable-next-line:no-bitwise
                Math.abs(Math.floor(Math.random() * x) ^ (new Date()).getTime()).toString(36);
        };
        Utils.areEqual = function (str1, str2) {
            return (str1 ? str1.toString().toUpperCase() : undefined) ===
                (str2 ? str2.toString().toUpperCase() : undefined);
        };
        Utils.toSafeString = function (o) {
            return (o === undefined || o === null ? "" : String(o));
        };
        Utils.supportsFullscreen = function () {
            var doc = document;
            return !!(doc.documentElement.requestFullscreen ||
                doc.documentElement.msRequestFullscreen ||
                doc.documentElement.mozRequestFullScreen ||
                doc.documentElement.webkitRequestFullscreen);
        };
        Utils.toggleFullscreen = function () {
            var doc = document;
            if (!doc.fullscreenElement && // alternative standard method
                !doc.mozFullScreenElement &&
                !doc.webkitFullscreenElement &&
                !doc.msFullscreenElement) { // current working methods
                if (doc.documentElement.requestFullscreen) {
                    doc.documentElement.requestFullscreen();
                }
                else if (doc.documentElement.msRequestFullscreen) {
                    doc.documentElement.msRequestFullscreen();
                }
                else if (doc.documentElement.mozRequestFullScreen) {
                    doc.documentElement.mozRequestFullScreen();
                }
                else if (doc.documentElement.webkitRequestFullscreen) {
                    doc.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            }
            else {
                if (doc.exitFullscreen) {
                    doc.exitFullscreen();
                }
                else if (doc.msExitFullscreen) {
                    doc.msExitFullscreen();
                }
                else if (doc.mozCancelFullScreen) {
                    doc.mozCancelFullScreen();
                }
                else if (doc.webkitExitFullscreen) {
                    doc.webkitExitFullscreen();
                }
            }
        };
        Utils.supportsVr = function () {
            try {
                if (window.navigator.getVRDisplays) {
                    return window.navigator.getVRDisplays().then(function (displays) {
                        var res = false;
                        if (displays.length) {
                            var userAgent = window.navigator.userAgent;
                            var deviceIncapable = /iPad|iPhone|iPod/.test(userAgent);
                            if (/Android/.test(userAgent)) {
                                deviceIncapable = /^(?!.*Mobile).*$/.test(userAgent);
                            }
                            res = displays[0].capabilities.canPresent && !deviceIncapable;
                        }
                        return res;
                    });
                }
                else {
                    return Q.when(false);
                }
            }
            catch (e) {
                return Q.when(false);
            }
        };
        Utils.isIos = function () {
            if (!this._iosChecked) {
                this._isIos = new RegExp("/iPad|iPhone|iPod/").test(navigator.userAgent) && !window.MSStream;
                this._iosChecked = true;
            }
            return this._isIos;
        };
        /**
         * sends a message to the parent page, if the current page is in an iframe
         */
        Utils.sendMessageToParent = function (msg) {
            //if we are not in an iframe, then window.parent just returns the window we are in
            if (window) {
                window.postMessage(msg, "*");
            }
            if (window.parent && window.parent != window) {
                window.parent.postMessage(msg, "*");
            }
        };
        Utils.downloadFile = function (url) {
            var ext = Utils.getExtension(url);
            var filename = Utils.getFilenameWithoutExtension(url);
            var link = $("<a/>");
            link.attr("href", url)
                .attr("target", "_blank")
                .attr("download", filename + "." + ext)[0].click();
        };
        /**
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * N milliseconds. If `immediate` is passed, trigger the function on the
         * leading edge, instead of the trailing.
         */
        Utils.debounce = function (func, wait, immediate) {
            var timeout;
            return function () {
                var context = this;
                var args = arguments;
                var later = function () {
                    timeout = null;
                    if (!immediate)
                        func.apply(context, args);
                };
                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow)
                    func.apply(context, args);
            };
        };
        /// **
        // * debounces a promise returning function so that at any instant only one call is pending
        // * @param func
        // */
        // public static promiseDebounce(func: Function) {
        //    var pending = null;
        //    function clear() { pending = null; }
        //    return function () {
        //        var ctx = this;
        //        if (pending) return pending;
        //        pending = func.apply(ctx, arguments);
        //        pending.then(clear, clear);
        //        return pending;
        //    }
        // }
        /**
         * throttles a function to only be called at most only once every n milliseconds
         */
        Utils.throttle = function (fn, threshhold, scope) {
            var last;
            var deferTimer;
            return function () {
                var context = scope || this;
                var args = arguments;
                if (threshhold <= 0) {
                    fn.apply(context, args);
                }
                else {
                    var now_1 = +new Date();
                    if (last && now_1 < last + threshhold) {
                        // hold on to it
                        clearTimeout(deferTimer);
                        deferTimer = setTimeout(function () {
                            last = now_1;
                            fn.apply(context, args);
                        }, threshhold);
                    }
                    else {
                        last = now_1;
                        fn.apply(context, args);
                    }
                }
            };
        };
        Utils.getRelativePos = function (child, ancestor) {
            var left = 0;
            var top = 0;
            var el = child;
            do {
                left += el.offsetLeft;
                top += el.offsetTop;
            } while ((el = el.offsetParent) && el !== ancestor);
            return { left: left, top: top };
        };
        Utils.escapeMarkup = function (value) {
            var textNode = document.createTextNode(value);
            var div = document.createElement('div');
            div.appendChild(textNode);
            return div.innerHTML;
        };
        Utils.scrollIntoView = function (o) {
            if (!o.elem)
                return;
            var $elem = $(o.elem);
            var $scrollParent = $elem.scrollParent();
            o.nearestStartPadding = o.nearestStartPadding || 0;
            o.nearestEndPadding = o.nearestEndPadding || 0;
            var set = function (scrollProp, value) {
                var _a;
                if (o.animate) {
                    $scrollParent.animate((_a = {}, _a[scrollProp] = value, _a), 150);
                }
                else {
                    $scrollParent[0][scrollProp] = value;
                }
            };
            var elemPos = this.getRelativePos(o.elem, $scrollParent[0]);
            var elemRect = o.elem.getBoundingClientRect();
            if (o.mode == exports.eScrollMode.nearest) {
                if (o.horizontal) {
                    var elemLeft = elemPos.left;
                    var elemRight = elemLeft + elemRect.width;
                    var scrollLeft = $scrollParent[0].scrollLeft;
                    var containerWidth = $scrollParent[0].clientWidth;
                    if (elemLeft - scrollLeft < 0) {
                        set("scrollLeft", elemLeft - o.nearestStartPadding);
                    }
                    else if (elemRight > scrollLeft + containerWidth) {
                        set("scrollLeft", elemRight - containerWidth + o.nearestEndPadding);
                    }
                }
                else {
                    var elemTop = elemPos.top;
                    var elemBottom = elemTop + elemRect.height;
                    var scrollTop = $scrollParent[0].scrollTop;
                    var containerHeight = $scrollParent[0].clientHeight;
                    if (elemTop - scrollTop < 0) {
                        set("scrollTop", elemTop - o.nearestStartPadding);
                    }
                    else if (elemBottom > scrollTop + containerHeight) {
                        set("scrollTop", elemBottom - containerHeight + o.nearestEndPadding);
                    }
                }
            }
            else if (o.mode == exports.eScrollMode.middleIfNecessary) {
                if (o.horizontal) {
                    var elemLeft = elemPos.left;
                    var elemWidth = elemRect.width;
                    var scrollLeft = $scrollParent[0].scrollLeft;
                    var containerWidth = $scrollParent[0].clientWidth;
                    if (elemLeft - scrollLeft < 0 || elemLeft + elemWidth > scrollLeft + containerWidth) {
                        var newScrollLeft = elemLeft + (elemWidth / 2) - (containerWidth / 2);
                        //if the elem is taller than the scroll window, we at least want the top visible
                        if (newScrollLeft > elemLeft)
                            newScrollLeft = elemLeft;
                        set("scrollLeft", newScrollLeft);
                    }
                }
                else {
                    var elemTop = elemPos.top;
                    var elemHeight = elemRect.height;
                    var scrollTop = $scrollParent[0].scrollTop;
                    var containerHeight = $scrollParent[0].clientHeight;
                    if (elemTop - scrollTop < 0 || elemTop + elemHeight > scrollTop + containerHeight) {
                        var newScrollTop = elemTop + (elemHeight / 2) - (containerHeight / 2);
                        //if the elem is taller than the scroll window, we at least want the top visible
                        if (newScrollTop > elemTop)
                            newScrollTop = elemTop;
                        set("scrollTop", newScrollTop);
                    }
                }
            }
            // let itemPosition = $item.position();
            // let itemBottom = itemPosition.top + $item.outerHeight(true);
            // let scrollTop = $scrollParent.scrollTop();
            // $scrollParent.scrollTop(scrollTop + itemBottom - $scrollParent.innerHeight());
        };
        Utils.MOBILE_WIDTH = 847;
        Utils.ABS_URL_REGEX = /^(?:[a-z]+:)?\/\//i;
        Utils.GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
        return Utils;
    }());

    var MessageDispatcher = /** @class */ (function () {
        function MessageDispatcher(postTo, listenOn, $q) {
            var _this = this;
            this.postTo = postTo;
            this.listenOn = listenOn;
            this.$q = $q;
            this.asks = [];
            this.listens = [];
            // catch messages coming from the iframe
            listenOn.addEventListener("message", function (event) {
                var msg = event.data;
                if (msg) {
                    // if we are on the ask side, then we need to see if an answer came in
                    var ask = _this.asks.find(function (a) { return a.msg.id == msg.id; });
                    if (ask) {
                        // remove the ask
                        _this.asks.remove(ask);
                        // resolve the promise
                        ask.deferred.resolve(msg.data);
                    }
                    else { // if we are on the listen side, then we're listening for a name
                        var listenMsg_1 = { name: msg.name, id: msg.id, data: msg.data };
                        var listens = _this.listens.filter(function (l) { return l.name == msg.name; });
                        listens.forEach(function (l) {
                            l.handler(listenMsg_1);
                        });
                    }
                }
            });
        }
        MessageDispatcher.prototype.ask = function (name, data) {
            var deferred = this.$q.defer();
            var msg = {
                id: Utils.shortId(),
                name: name,
                data: data // data sent through postMessage cannot have functions or methods on it
            };
            this.asks.push({ msg: msg, deferred: deferred });
            this.postMessage(msg);
            return deferred.promise;
        };
        MessageDispatcher.prototype.listen = function (name, handler) {
            this.listens.push({ name: name, handler: handler });
        };
        MessageDispatcher.prototype.removeListen = function (name, handler) {
            if (handler) { // if handler is specified, we only remove that specific listen
                this.listens.removeWhere(function (l) { return l.name == name && l.handler == handler; });
            }
            else {
                this.listens.removeWhere(function (l) { return l.name == name; });
            }
        };
        MessageDispatcher.prototype.answer = function (originalMsg, data) {
            // post message back to other window
            var msg = {
                id: originalMsg.id,
                name: originalMsg.name + " answer",
                data: data
            };
            this.postMessage(msg);
        };
        MessageDispatcher.prototype.inWorker = function () {
            return typeof Worker === "undefined";
        };
        MessageDispatcher.prototype.postMessage = function (msg) {
            if (this.inWorker() || this.postTo instanceof Worker) {
                this.postTo.postMessage(msg);
            }
            else {
                this.postTo.postMessage(msg, "*");
            }
        };
        return MessageDispatcher;
    }());

    /**
        * helpers for filtering and ranking arrays for autocomplete type functionality
        */
    var SearchUtils = /** @class */ (function () {
        function SearchUtils() {
        }
        SearchUtils.search = function (query, arr, valueFn, maxItems, matchFn, noMatchFn) {
            if (maxItems === void 0) { maxItems = 10; }
            if (matchFn === void 0) { matchFn = null; }
            if (noMatchFn === void 0) { noMatchFn = null; }
            var sorted = [];
            var add = function (item) {
                var value = valueFn(item);
                var score = scoreDb[value];
                var indexMin = 0;
                var indexMax = sorted.length;
                while (indexMin < indexMax) {
                    var indexMid = Math.floor((indexMin + indexMax) / 2);
                    var midScore = scoreDb[valueFn(sorted[indexMid])];
                    //if the insert item is less than existing
                    if (score > midScore) {
                        indexMax = indexMid;
                    }
                    else if (score < midScore) {
                        indexMin = indexMid + 1;
                    }
                    else { //they are equal
                        indexMin = indexMid;
                        break;
                    }
                }
                sorted.splice(indexMin, 0, item);
            };
            //first get rid of duplicates
            var db = {};
            arr.forEach(function (item) { return db[valueFn(item)] = item; });
            var scoreDb = {};
            var keys = Object.keys(db);
            for (var i = 0; i < keys.length; i++) {
                var key = keys[i];
                var score = 0;
                if (key && query)
                    score = SearchUtils.score(key, query, 0);
                if (score > 0) {
                    scoreDb[key] = score;
                    add(db[key]);
                    if (matchFn)
                        matchFn(db[key]);
                }
                else {
                    if (noMatchFn)
                        noMatchFn(db[key]);
                }
            }
            if (maxItems > 0 && sorted.length >= maxItems) {
                sorted = sorted.slice(0, maxItems - 1);
            }
            return sorted;
        };
        /*!
            * string_score.js: String Scoring Algorithm 0.1.22
            *
            * http://joshaven.com/string_score
            * https://github.com/joshaven/string_score
            */
        SearchUtils.score = function (phrase, query, fuzziness) {
            // If the string is equal to the word, perfect match.
            if (phrase === query) {
                return 1;
            }
            //if it's not a perfect match and is empty return 0
            if (query === "") {
                return 0;
            }
            var runningScore = 0, charScore, finalScore, string = phrase, lString = string.toLowerCase(), strLength = string.length, lWord = query.toLowerCase(), wordLength = query.length, idxOf, startAt = 0, fuzzies = 1, fuzzyFactor, i;
            // Cache fuzzyFactor for speed increase
            if (fuzziness) {
                fuzzyFactor = 1 - fuzziness;
            }
            // Walk through word and add up scores.
            // Code duplication occurs to prevent checking fuzziness inside for loop
            if (fuzziness) {
                for (i = 0; i < wordLength; i += 1) {
                    // Find next first case-insensitive match of a character.
                    idxOf = lString.indexOf(lWord[i], startAt);
                    if (idxOf === -1) {
                        fuzzies += fuzzyFactor;
                    }
                    else {
                        if (startAt === idxOf) {
                            // Consecutive letter & start-of-string Bonus
                            charScore = 0.7;
                        }
                        else {
                            charScore = 0.1;
                            // Acronym Bonus
                            // Weighing Logic: Typing the first character of an acronym is as if you
                            // preceded it with two perfect character matches.
                            if (string[idxOf - 1] === ' ') {
                                charScore += 0.5;
                            }
                        }
                        // Same case bonus.
                        if (string[idxOf] === query[i]) {
                            charScore += 0.1;
                        }
                        // Update scores and startAt position for next round of indexOf
                        runningScore += charScore;
                        startAt = idxOf + 1;
                    }
                }
            }
            else {
                for (i = 0; i < wordLength; i += 1) {
                    idxOf = lString.indexOf(lWord[i], startAt);
                    if (-1 === idxOf) {
                        return 0;
                    }
                    if (startAt === idxOf) {
                        charScore = 0.7;
                    }
                    else {
                        charScore = 0.1;
                        if (string[idxOf - 1] === ' ') {
                            charScore += 0.5;
                        }
                    }
                    if (string[idxOf] === query[i]) {
                        charScore += 0.1;
                    }
                    runningScore += charScore;
                    startAt = idxOf + 1;
                }
            }
            // Reduce penalty for longer strings.
            finalScore = 0.5 * (runningScore / strLength + runningScore / wordLength) / fuzzies;
            if ((lWord[0] === lString[0]) && (finalScore < 0.85)) {
                finalScore += 0.15;
            }
            return finalScore;
        };
        return SearchUtils;
    }());

    var UnitOfMeasurement = /** @class */ (function () {
        function UnitOfMeasurement() {
        }
        UnitOfMeasurement.create = function (name, multiplier, offset) {
            var result = new UnitOfMeasurement();
            result.name = name;
            result.multiplier = multiplier;
            result.offset = offset ? offset : 0;
            return result;
        };
        return UnitOfMeasurement;
    }());
    var Units = /** @class */ (function () {
        function Units() {
        }
        Units.convert = function (type, from, to, value) {
            var measurements = Units[type];
            if (!measurements)
                throw new Error("Unit type " + type + " not found");
            var fromUnit = measurements.find(function (m) { return m.name == from; });
            if (!fromUnit)
                throw new Error("Unit " + from + "not found");
            var toUnit = measurements.find(function (m) { return m.name == to; });
            if (!toUnit)
                throw new Error("Unit " + to + " not found");
            return Math.round(((value * 1 / fromUnit.multiplier * toUnit.multiplier) -
                ((toUnit.offset * toUnit.multiplier) - (fromUnit.offset * fromUnit.multiplier))) * 10000) / 10000;
        };
        Units.distance = [
            UnitOfMeasurement.create("meters", 1),
            UnitOfMeasurement.create("millimeters", 1000),
            UnitOfMeasurement.create("centimeters", 100),
            UnitOfMeasurement.create("kilometers", 0.001),
            UnitOfMeasurement.create("inches", 39.3701),
            UnitOfMeasurement.create("feet", 3.28084),
            UnitOfMeasurement.create("yards", 1.09361),
            UnitOfMeasurement.create("miles", 0.000621371)
        ];
        Units.area = [
            UnitOfMeasurement.create("sq. millimeters", 1000000),
            UnitOfMeasurement.create("sq. centimeters", 10000),
            UnitOfMeasurement.create("sq. meters", 1),
            UnitOfMeasurement.create("sq. kilometers", 0.000001),
            UnitOfMeasurement.create("sq. yard", 1.19599),
            UnitOfMeasurement.create("sq. feet", 10.7639),
            UnitOfMeasurement.create("sq. inch", 1550),
            UnitOfMeasurement.create("hectacre", 0.0001),
            UnitOfMeasurement.create("acre", 0.000247105)
        ];
        Units.volume = [
            UnitOfMeasurement.create("liters", 1),
            UnitOfMeasurement.create("US gallons", 0.264172),
            UnitOfMeasurement.create("US quarts", 1.05669),
            UnitOfMeasurement.create("US pints", 2.11338),
            UnitOfMeasurement.create("US cups", 4.16667),
            UnitOfMeasurement.create("US ounces", 33.814),
            UnitOfMeasurement.create("US tablespoons", 67.628),
            UnitOfMeasurement.create("US teaspoons", 202.884),
            UnitOfMeasurement.create("cubic meters", 0.001),
            UnitOfMeasurement.create("milliliters", 1000),
            UnitOfMeasurement.create("imperial gallons", 0.219969),
            UnitOfMeasurement.create("imperial quarts", 0.879877),
            UnitOfMeasurement.create("imperial pints", 1.75975),
            UnitOfMeasurement.create("imperial cups", 3.51951),
            UnitOfMeasurement.create("imperial ounces", 35.1951),
            UnitOfMeasurement.create("imperial tablespoons", 56.3121),
            UnitOfMeasurement.create("imperial teaspoons", 168.936),
            UnitOfMeasurement.create("cubic feet", 0.0353147),
            UnitOfMeasurement.create("cubic inches", 61.0237)
        ];
        /*public static temperature: UnitOfMeasurement[] = [
            UnitOfMeasurement.create("kelvin", 1),
            UnitOfMeasurement.create("celsius", 1, 272.15),
            UnitOfMeasurement.create("fahrenheit", 1.8, 255.372)
        ];*/
        Units.weight = [
            UnitOfMeasurement.create("kilograms", 1),
            UnitOfMeasurement.create("grams", 1000),
            UnitOfMeasurement.create("metric tons", 0.001),
            UnitOfMeasurement.create("milligrams", 1000000),
            UnitOfMeasurement.create("micrograms", 1000000000),
            UnitOfMeasurement.create("imperial tons", 0.000984207),
            UnitOfMeasurement.create("US tons", 0.00110231),
            UnitOfMeasurement.create("stones", 0.157473),
            UnitOfMeasurement.create("pounds", 2.20462),
            UnitOfMeasurement.create("ounces", 35.274)
        ];
        Units.pressure = [
            UnitOfMeasurement.create("pascals", 1),
            UnitOfMeasurement.create("bars", 0.00001),
            UnitOfMeasurement.create("atmospheres", 0.0000098692),
            UnitOfMeasurement.create("psi", 0.000145038),
            UnitOfMeasurement.create("torrs", 0.00750062),
            UnitOfMeasurement.create("hg", 0.0002953)
        ];
        Units.angle = [
            UnitOfMeasurement.create("radians", 1),
            UnitOfMeasurement.create("degrees", 57.2958),
            UnitOfMeasurement.create("gradians", 63.662),
            UnitOfMeasurement.create("milliradians", 1000),
            UnitOfMeasurement.create("minutes", 3437.75),
            UnitOfMeasurement.create("seconds", 206265)
        ];
        return Units;
    }());

    exports.ArrayExt = ArrayExt;
    exports.Color = Color;
    exports.KbEvent = KbEvent;
    exports.Logger = Logger;
    exports.Map = Map;
    exports.MessageDispatcher = MessageDispatcher;
    exports.SNAP_VERSION = SNAP_VERSION;
    exports.SearchUtils = SearchUtils;
    exports.UnitOfMeasurement = UnitOfMeasurement;
    exports.Units = Units;
    exports.Utils = Utils;
    exports.currencies = currencies;

    return exports;

}({}, Q));


/*
    This file is a shim to make rule utilities available globally.  We concat it with the rules bundle
    after the bundle is already made.
*/

var Units = tools.Units;
//# sourceMappingURL=tools.js.map
